import React, { useRef, useState, useEffect, useContext } from 'react';
import { useNavigate, useParams } from 'react-router';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import { InputSwitch } from 'primereact/inputswitch';
import { decodeToken } from 'react-jwt';
import { Toast } from 'primereact/toast';
import { SelectButton } from 'primereact/selectbutton';

import Card from '../../../Base/Components/Card/Card';
import { useForm } from '../../../Base/Hooks/useForm';
import Loader from '../../../Base/Components/Loader/Loader';
import { toastShow } from '../../../Base/Services/ToastService';
import { formatCodigoProveedor } from '../../../Base/Services/Format';
import AutoCompleteDropdown from '../../../Base/Components/Form/AutoCompleteDropdown';
import { ArchivoConvertSQL, downloadBase64Data } from '../../../Base/Services/ArchivosService';

import { getCuentasBancariasTotales } from '../../../Base/API/Global/Bancos/BancosRequest';
import { getCountriesList } from '../../../Base/API/Countries/CountriesRequest';
import { getBancosList, getCurrencyIPS, getCurrencyToken } from '../../../Base/API/Global/Currency/CurrencyRequest';
import {
  getArchivoFormatoInscripcion, getArchivoProveedor, getProveedorInfo,
  saveArchivoFactura, saveArchivoBIC, saveArchivoConstanciaPagos, saveArchivoEscrituraConstitucion,
  saveArchivoFormatoInscripcion, saveArchivoPermisoOperaciones, saveArchivoRegistroDexonera, saveInscripcionProveedor,
  saveRegistroExonerado,
  getArchivo,
  saveArchivoCertificado
} from '../../../Base/API/Compras/Proveedores/ProveedoresRequests';
import { getListaCorreoToken } from '../../../Base/API/IT/ListaCorreos/ListaCorreosRequest';
import { getUsuariosActivosToken } from '../../../Base/API/IT/Usuarios/UsersRequests';
import { FinalizarSolicitudEdicion } from '../../../Base/API/Proveedores/ProveedoresRequest';

import { getLabel } from '../../../Base/Services/Language/LanguageService';
import { InscripcionProveedoresLang } from './Lang/InscripcionProveedoresLang';
import './Styles/Proveedores.scss'
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { EnviarCorreo } from '../../Services/Email/EnviarCorreo';
import { AuthContext } from '../../Context/AuthContext/AuthContext';
import DialogEstadoRevision from "../Proveedores/DialogEstadoRevision";
import FormatoInscripcionPDF from './FormatoInscripcionPDF';
import { Dialog } from 'primereact/dialog';
import { jwtDecode } from 'jwt-decode';
import { RadioButton } from 'primereact/radiobutton';
import { Tag } from 'primereact/tag';
import { getDateString, getDateTimeString, getDateTimeStringSQL24 } from '../../Services/Moment/Luxon';
import { getInscripcionProveedorEditable } from '../../../Base/API/Proveedores/ProveedoresRequest';

const InscripcionProveedores = () => {
  const { userAuth } = useContext(AuthContext);
  const navigate = useNavigate();

  const { config, changeTheme, changeLanguage } = useContext(ConfigContext);

  const params = useParams();

  const Token = params.Token;
  const lang = params.lang !== 'null' ? params.lang : 'es';
  const decoded = jwtDecode(Token);
  const idUser = decoded.IdUser;

  const toast = useRef(null);
  const IdHonduras = 95;

  const [showDialogEstadoRevision, setShowDialogEstadoRevision] = useState(false);

  const [tokenInfo, setTokenInfo] = useState(null);
  const [initializing, setInitializing] = useState(true);
  const [idCustomer, setIdCustomer] = useState(null);
  const [Bancos, setBancos] = useState([]);
  const [Countries, setCountries] = useState([]);
  const [Currencies, setCurrencies] = useState([]);
  const [showMessages, setShowMessages] = useState({ error: false });
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editable, setEditable] = useState(true);
  const [editable2, setEditable2] = useState(true);
  const [botonRegistro, setBotonRegistro] = useState(false);
  const [ArchivoSelected, setArchivoSelected] = useState(0);
  const [idioma, setIdioma] = useState('es');
  const [listaCorreos, setListaCorreos] = useState([]);

  // ARCHIVOS

  const [ArchivoBIC, setArchivoBIC] = useState(null);
  const [resultArchivoBIC, setResultArchivoBIC] = useState(null);
  const [ArchivoPermisoOperaciones, setArchivoPermisoOperaciones] = useState(null);
  const [resultArchivoPermisoOperaciones, setResultArchivoPermisoOperaciones] = useState(null);
  const [ArchivoRegistroExonerado, setArchivoRegistroExonerado] = useState(null);
  const [resultArchivoRegistroExonerado, setResultArchivoRegistroExonerado] = useState(null);
  const [ArchivoConstPagosCuenta, setArchivoConstPagosCuenta] = useState(null);
  const [resultArchivoConstPagosCuenta, setResultArchivoConstPagosCuenta] = useState(null);
  const [ArchivoEscrituraConstitucion, setArchivoEscrituraConstitucion] = useState(null);
  const [resultArchivoEscrituraConstitucion, setResultArchivoEscrituraConstitucion] = useState(null);
  const [ArchivoFactura, setArchivoFactura] = useState(null);
  const [resultArchivoFactura, setResultArchivoFactura] = useState(null);

  const [showDialogFormato, setShowDialogFormato] = useState(false);
  const [selectedFormato, setSelectedFormato] = useState(null);
  const [showDialogIncompleto, setShowDialogIncompleto] = useState(false);
  const [showDialogAyuda, setShowDialogAyuda] = useState(false);
  const [listaFaltantes, setListaFaltantes] = useState([]);
  const [ArchivoCertificado, setArchivoCertificado] = useState(null);
  const [resultArchivoCertificado, setResultArchivoCertificado] = useState(null);
  const [solicitudEdicionActiva, setSolicitudEdicionActiva] = useState(null);



  const { values, handleInputChange, setValues } = useForm({
    CustomerName: '', // CustomerName
    numeroIdentificacionTributaria: '', //RTN
    Country: null, //Country
    State: '', //State
    City: '',
    Address: '', // DIRECCION COMERCIALBICBIC
    Tel: '', // TELEFONO DE REFERENCIA
    Email: '', // EMAIL
    PrincipalActividadEconomica: '',
    TipoFacturacion: null, // TIPO DE FACTURACION
    CasaMatriz: '',
    DireccionCasaMatriz: '',

    // CONTACTO REPRESENTANTE LEGAL
    NombreRepresentanteLegal: '',
    CorreoRepresentanteLegal: '',


    // CONTACTO CUENTAS POR COBRAR
    ContactoCuentasPorCobrar: '',
    CorreoCuentasPorCobrar: '',
    TelefonoCuentasPorCobrar: '',


    // INFORMACION BANCARIA HONDURAS
    NumeroCuentaBancaria: '',
    TitularCuenta: '',
    Banco: null,
    TipoCuenta: null,
    Currency: null,

    // INFORMACION BANCARIA EXTRANJERO
    // BANCO INTERMEDIARIO
    BancoIntermediarioNombre: '',
    BancoIntermediarioDireccion: '',
    BancoIntermediarioSwift: '',
    BancoIntermediarioAbaBin: '',
    BancoIntermediarioCuenta: '',
    // BANCO BENEFCIARIO
    BancoBeneficiarioNombre: '',
    BancoBeneficiarioDireccion: '',
    BancoBeneficiarioSwift: '',
    BancoBeneficiarioNombreBeneficiario: '',
    BancoBeneficiarioCuenta: '',
    BancoBeneficiarioAbaBin: '',



    // REFERENCIAS COMERCIALES
    ref1Nombre: '',
    ref1Telefono: '',
    ref1Correo: '',
    ref2Nombre: '',
    ref2Telefono: '',
    ref2Correo: '',



    // DOCUMENTACION
    FileRTN: null,
    FilePermisoOperaciones: null,
    FileNacional: null,
    FileEscrituraConstitucion: null,
    FileCertificado: null,



    // AUTORIZACION
    AutorizacionDeposito: false,

    // ZONA LIBRE
    ZonaLibre: false,
    NombreZonaLibre: null,
    DireccionZonaLibre: null,

    RegistroExonerado: null,
    FechaVencimiento: new Date(),
    FechaInicio: new Date(),

    InformacionEmpresa: false,
    InformacionContacto: false,
    InformacionBancaria: false,
    InformacionComercial: false,
    InformacionFinanciera: false,
    Documentacion: false

  });
  const sectionRef = useRef(null);
  const handleScroll = () => {
    sectionRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "start"      // puede ser "start", "center", "end"
    });
  };

  const tiposFactura = [
    // { tipo: 'Facturación Electrónica', type: 'Electronic billing' },
    // { tipo: 'Facturación Física', type: 'Physical billing' },
    // { tipo: 'Boleta por honorarios profesionales', type: 'Invoice for professional services' },
    { tipo: 'Autoimpresor', type: 'Autoimpresor' },
    { tipo: 'Impresión por imprenta', type: 'Imporesion imprenta' }
  ]

  const colorTexto = config.theme === 'Dark' ? '#919191' : 'gray';
  const tiposCuentas = [
    { tipo: 'Ahorros' },
    { tipo: 'Cheques' }
  ]

  const obtenerSolicitudEdicionActiva = async (IdCustomer) => {
    const result = await getInscripcionProveedorEditable(IdCustomer, 3118, Token);
    const data = result?.data ?? result;
    setSolicitudEdicionActiva(data?.[0] ?? null);
  };

  const getCompanyInfo = async (IdCustomer) => {
    setLoading(true);
    const estadosHabilitadoEdicion = [3722]

    const result = await getProveedorInfo(IdCustomer, Token);
    setSelectedFormato(result[0])
    if (result.length > 0) {
      const bancosT = await getBancosList(Token);
      const contriesT = await getCountriesList(Token);
      const currenciesT = await getCurrencyToken(Token);
      const pais = contriesT.find(x => x.Id === result[0].IdCountry);
      const tipoFactura = tiposFactura.find(x => x.tipo === result[0].TipoFacturacion);
      const banco = bancosT.find(x => x.IdBanco === result[0].IdBanco);
      const tipoCuenta = tiposCuentas.find(x => x.tipo === result[0].TipoCuenta);
      const moneda = currenciesT.find(x => x.IdCurrency === result[0].IdCurrency);
      const mondedaFin = currenciesT.find(x => x.IdCurrency === result[0].CurrencyFin);
      const paisBanco = contriesT.find(x => x.Id === result[0]?.IdPaisCuentaBancaria);
      setEditable(result[0].esEditable && estadosHabilitadoEdicion.includes(result[0].IdStatusRevision));
      setEditable2(result[0].esEditable);

      let selectedOption = null;
      if (result[0].DeduccionACH) {
        selectedOption = 'DeduccionACH';
      } else if (result[0].PagarCheque) {
        selectedOption = 'PagarCheque';
      }

      setValues({
        ...result[0],
        CustomerName: result[0].CustomerName,
        NombreComercial: result[0].NombreComercial,
        numeroIdentificacionTributaria: result[0].RTN,
        Country: pais,
        TipoFacturacion: tipoFactura,
        Banco: banco,
        TipoCuenta: tipoCuenta,
        Currency: moneda,
        CurrencyFin: mondedaFin,
        RegistroExonerado: result[0].RegistroExonerado,
        FechaVencimiento: result[0].FechaVencimiento ? new Date(result[0].FechaVencimiento) : null,
        FechaInicio: result[0]?.FechaInicio ? new Date(result[0].FechaInicio) : null,
        SinRegistroExonerado: result[0].SinRegistroExonerado,
        TieneConstPagosCuenta: result[0].TieneConstPagosCuenta,
        selectedOption: selectedOption,
        PaisCuentaBancaria: paisBanco,
        InformacionEmpresa: result[0]?.InformacionEmpresa || false,
        InformacionContacto: result[0]?.InformacionContacto || false,
        InformacionBancaria: result[0]?.InformacionBancaria || false,
        InformacionFinanciera: result[0]?.InformacionFinanciera || false,
        InformacionComercial: result[0]?.InformacionComercial || false,
        Documentacion: result[0]?.Documentacion || false,
      });
      setArchivoSelected(result[0].ZonaLibre ? 1 : 0)
    }
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }

  const getInfo = async () => {
    const bancosT = await getBancosList(Token);
    const contriesT = await getCountriesList(Token);
    const currenciesT = await getCurrencyToken(Token);
    const t = await getListaCorreoToken(Token);
    setListaCorreos(t.filter(e => e.IdListaCorreo === 1));
    setBancos(bancosT);
    setCountries(contriesT);
    let monedafilrada = currenciesT//.filter(e => e.IdCurrency !== 3)
    if (values?.IdCountry !== 95) {
      setCurrencies(monedafilrada)
    } else {
      setCurrencies(currenciesT);
    }
  }

  const verificarCampos = () => {
    let errors = {};
    let isValid = true;


    // INFOREMACION GENERAL
    if (!values.CustomerName) {
      errors.CustomerName = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.NombreComercial) {
      errors.NombreComercial = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.numeroIdentificacionTributaria) {
      errors.numeroIdentificacionTributaria = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Country) {
      errors.Country = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.State) {
      errors.State = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.City) {
      errors.City = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Address) {
      errors.Address = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Tel) {
      errors.Tel = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Email) {
      errors.Email = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.PrincipalActividadEconomica) {
      errors.PrincipalActividadEconomica = true;
      errors.General = true;
      isValid = false;
    }


    // CONTACTO REPRESENTANTE LEGAL
    // if (!formValues.NombreRepresentanteLegal) {
    //   errors.NombreRepresentanteLegal = true;
    //   errors.RepresentanteLegal = true;
    //   isValid = false;
    // }
    // if (!formValues.CorreoRepresentanteLegal) {
    //   errors.CorreoRepresentanteLegal = true;
    //   errors.RepresentanteLegal = true;
    //   isValid = false;
    // }

    // CONTACTO CUENTAS POR COBRAR
    if (!values.ContactoCuentasPorCobrar) {
      errors.ContactoCuentasPorCobrar = true;
      errors.CuentasPorCobrar = true;
      isValid = false;
    }
    if (!values.CorreoCuentasPorCobrar) {
      errors.CorreoCuentasPorCobrar = true;
      errors.CuentasPorCobrar = true;
      isValid = false;
    }
    if (!values.TelefonoCuentasPorCobrar) {
      errors.TelefonoCuentasPorCobrar = true;
      errors.CuentasPorCobrar = true;
      isValid = false;
    }
    if (!values.Currency) {
      errors.Currency = true;
      errors.Banco = true;
      isValid = false;
    }

    // CONTACTOS FINANZAS
    if (!values.refFin1Nombre) {
      errors.refFin1Nombre = true;
      errors.ConcactoFinanzas = true;
      isValid = false;
    }
    if (!values.refFin1Telefono) {
      errors.refFin1Telefono = true;
      errors.ConcactoFinanzas = true;
      isValid = false;
    }
    if (!values.refFin1Correo) {
      errors.refFin1Correo = true;
      errors.ConcactoFinanzas = true;
      isValid = false;
    }
    if (!values.refFin2Nombre) {
      errors.refFin2Nombre = true;
      errors.ConcactoFinanzas = true;
      isValid = false;
    }
    if (!values.refFin2Telefono) {
      errors.refFin2Telefono = true;
      errors.ConcactoFinanzas = true;
      isValid = false;
    }
    if (!values.refFin2Correo) {
      errors.refFin2Correo = true;
      errors.ConcactoFinanzas = true;
      isValid = false;
    }


    // INFORMACION BANCARIA
    if (!values.PaisCuentaBancaria) {
      errors.PaisCuentaBancaria = true;
      errors.General = true;
      isValid = false;
    }

    if ((values?.PaisCuentaBancaria?.Id) === IdHonduras) {
      // BANCOS NACIONALES
      if (!values.NumeroCuentaBancaria) {
        errors.NumeroCuentaBancaria = true;
        errors.Banco = true;
        isValid = false;
      }
      if (!values.TitularCuenta) {
        errors.TitularCuenta = true;
        errors.Banco = true;
        isValid = false;
      }
      if (!values.Banco) {
        errors.Banco = true;
        errors.Banco = true;
        isValid = false;
      }
      if (!values.TipoCuenta) {
        errors.TipoCuenta = true;
        errors.Banco = true;
        isValid = false;
      }

      if (!values.TipoFacturacion && values?.Country?.Id === IdHonduras) {
        errors.TipoFacturacion = true;
        errors.General = true;
        isValid = false;
      }

      // VALIDACIÓN PARA BANCOS DISTINTOS DE ATLÁNTIDA Y FICOHSA
      if (values.Banco && ![2, 19].includes(values.Banco.IdBanco)) {
        if (!values.selectedOption) {
          errors.selectedOption = true;
          errors.General = true;
          isValid = false;
        }
      }

    } else {
      // BANCOS EXTRAJEROS

      // BANCO BENEFICIARIO
      if (!values.BancoBeneficiarioNombre) {
        errors.BancoBeneficiarioNombre = true;
        errors.Banco = true;
        isValid = false;
      }
      // BancoBeneficiarioAbaBin
      if (!values.BancoBeneficiarioAbaBin) {
        errors.BancoBeneficiarioAbaBin = true;
        errors.Banco = true;
        isValid = false;
      }
      if (!values.BancoBeneficiarioDireccion) {
        errors.BancoBeneficiarioDireccion = true;
        errors.Banco = true;
        isValid = false;
      }
      if (!values.BancoBeneficiarioSwift) {
        errors.BancoBeneficiarioSwift = true;
        errors.Banco = true;
        isValid = false;
      }
      if (!values.BancoBeneficiarioNombreBeneficiario) {
        errors.BancoBeneficiarioNombreBeneficiario = true;
        errors.Banco = true;
        isValid = false;
      }
      if (!values.BancoBeneficiarioCuenta) {
        errors.BancoBeneficiarioCuenta = true;
        errors.Banco = true;
        isValid = false;
      }
    }

    // REFERENCIAS COMERCIALES
    if (!values.ref1Nombre) {
      errors.ref1Nombre = true;
      errors.ReferenciasComerciales = true;
      isValid = false;
    }
    if (!values.ref1Telefono) {
      errors.ReferenciasComerciales = true;
      errors.ref1Telefono = true;
      isValid = false;
    }
    if (!values.ref1Correo) {
      errors.ReferenciasComerciales = true;
      errors.ref1Correo = true;
      isValid = false;
    }
    if (!values.ref2Nombre) {
      errors.ReferenciasComerciales = true;
      errors.ref2Nombre = true;
      isValid = false;
    }
    if (!values.ref2Telefono) {
      errors.ReferenciasComerciales = true;
      errors.ref2Telefono = true;
      isValid = false;
    }
    if (!values.ref2Correo) {
      errors.ReferenciasComerciales = true;
      errors.ref2Correo = true;
      isValid = false;
    }


    // AUTORIZACION
    if (!values.AutorizacionDeposito) {
      errors.AutorizacionDeposito = true;
      isValid = false;
    }

    // ZONA LIBRE
    if (values?.Country?.Id === IdHonduras) {
      if (ArchivoSelected === 1 && !values.SinRegistroExonerado) {
        if (!values.NombreZonaLibre) {
          errors.NombreZonaLibre = true;
          errors.Documentos = true;
          isValid = false;
        }
        if (!values.DireccionZonaLibre) {
          errors.DireccionZonaLibre = true;
          errors.Documentos = true;
          isValid = false;
        }
        if (!values.RegistroExonerado) {
          errors.RegistroExonerado = true;
          errors.Documentos = true;
          isValid = false;
        }
        if (!values.FechaVencimiento) {
          errors.FechaVencimiento = true;
          errors.Documentos = true;
          isValid = false;
        }

        if (!values.FechaInicio) {
          errors.FechaInicio = true;
          errors.Documentos = true;
          isValid = false;
        }


        if (values.FechaVencimiento < values.FechaInicio) {
          errors.FechaInicio = true;
          errors.Documentos = true;
          isValid = false;
        }
      }
    }



    if (resultArchivoBIC === null && values.BICName === null) {
      errors.resultArchivoBIC = true;
      errors.Documentos = true;
      isValid = false;

    }

    if (resultArchivoFactura === null && values.FacturaName === null) {
      errors.resultArchivoFactura = true;
      errors.Documentos = true;
      isValid = false;
    }

    if (values?.Country?.Id === IdHonduras) {
      if (ArchivoSelected === 1) {
        if (resultArchivoRegistroExonerado === null && values.RegistroExoneradoName === null && !values.SinRegistroExonerado) {
          errors.resultArchivoRegistroExonerado = true;
          errors.Documentos = true;
          isValid = false;
        }
      } else {
        if (values?.TieneConstPagosCuenta === true) {
          if (resultArchivoConstPagosCuenta === null && values.ConstPagosName === null) {
            errors.resultArchivoConstPagosCuenta = true;
            errors.Documentos = true;
            isValid = false;
          }
          if (!values.FechaVencimiento) {
            errors.FechaVencimiento = true;
            errors.Documentos = true;
            isValid = false;
          }

          if (!values.FechaInicio) {
            errors.FechaInicio = true;
            errors.Documentos = true;
            isValid = false;
          }

        }
      }

      if (resultArchivoPermisoOperaciones === null && values.PermisoOperacionesName === null) {
        errors.resultArchivoPermisoOperaciones = true;
        errors.Documentos = true;
        isValid = false;
      }
    }
    if (resultArchivoEscrituraConstitucion === null && values.EscrituraConstitucionName === null) {
      errors.setResultArchivoEscrituraConstitucion = true;
      errors.Documentos = true;
      isValid = false;
    }

    // if (values?.Country?.Id !== IdHonduras) {
    //   if (resultArchivoCertificado === null && values.CertificadoName === null) {
    //     errors.resultArchivoCertificado = true;
    //     errors.Documentos = true;
    //     isValid = false;
    //   }
    // }

    // TAMAÑO DE ARCHIVOS
    if (ArchivoPermisoOperaciones?.size > 5 * 1024 * 1024) {
      errors.resultArchivoPermisoOperaciones = true;
      errors.Documentos = true;
      isValid = false;
      errors.size = true;
    }

    if (ArchivoEscrituraConstitucion?.size > 10 * 1024 * 1024) {
      errors.resultArchivoEscrituraConstitucion = true;
      errors.Documentos = true;
      isValid = false;
      errors.size = true;
    }

    if (ArchivoRegistroExonerado?.size > 5 * 1024 * 1024) {
      errors.resultArchivoRegistroExonerado = true;
      errors.Documentos = true;
      isValid = false;
      errors.size = true;
    }

    if (ArchivoConstPagosCuenta?.size > 5 * 1024 * 1024) {
      errors.resultArchivoConstPagosCuenta = true;
      errors.Documentos = true;
      isValid = false;
      errors.size = true;
    }
    if (ArchivoBIC?.size > 5 * 1024 * 1024) {
      errors.resultArchivoBIC = true;
      errors.Documentos = true;
      isValid = false;
      errors.size = true;
    }


    if (ArchivoCertificado?.size > 5 * 1024 * 1024) {
      errors.resultArchivoCertificado = true;
      errors.Documentos = true;
      isValid = false;
      errors.size = true;
    }

    // INFORMACION FINANCIERA 
    if (!values.CurrencyFin) {
      errors.CurrencyFin = true;
      errors.Financiera = true;
      isValid = false;
    }
    if (!values.ActivosCorrientes) {
      errors.ActivosCorrientes = true;
      errors.Financiera = true;
      isValid = false;
    }
    if (!values.TotalActivos) {
      errors.TotalActivos = true;
      errors.Financiera = true;
      isValid = false;
    }
    if (!values.PasivosCorrientes) {
      errors.PasivosCorrientes = true;
      errors.Financiera = true;
      isValid = false;
    }
    if (!values.TotalPasivos) {
      errors.TotalPasivos = true;
      errors.Financiera = true;
      isValid = false;
    }

    setShowMessages({ ...errors, error: !isValid });

    const mensajesErrores = {
      CustomerName: "Nombre Legal",
      NombreComercial: "Nombre Comercial",
      numeroIdentificacionTributaria: "RTN/NIT/RUC/TAX ID",
      Country: "País",
      State: "Departamento / Estado",
      City: "Ciudad",
      Address: "Dirección",
      Tel: "Teléfono",
      Email: "Correo electrónico",
      PrincipalActividadEconomica: "Actividad económica principal",
      TipoFacturacion: "Tipo de facturación",

      ContactoCuentasPorCobrar: "Contacto Cuentas por Cobrar",
      CorreoCuentasPorCobrar: "Correo Cuentas por Cobrar",
      TelefonoCuentasPorCobrar: "Teléfono Cuentas por Cobrar",
      Currency: "Moneda Bancaria",

      refFin1Nombre: "Nombre Contacto Financiero 1",
      refFin1Telefono: "Teléfono Contacto Financiero 1",
      refFin1Correo: "Correo Contacto Financiero 1",
      refFin2Nombre: "Nombre Contacto Financiero 2",
      refFin2Telefono: "Teléfono Contacto Financiero 2",
      refFin2Correo: "Correo Contacto Financiero 2",

      NumeroCuentaBancaria: "Número de Cuenta Bancaria",
      TitularCuenta: "Titular de la Cuenta",
      Banco: "Banco",
      TipoCuenta: "Tipo de Cuenta",

      BancoBeneficiarioNombre: "Nombre del Banco Beneficiario",
      BancoBeneficiarioAbaBin: "ABA / BIN del Banco Beneficiario",
      BancoBeneficiarioDireccion: "Dirección del Banco Beneficiario",
      BancoBeneficiarioSwift: "Código SWIFT",
      BancoBeneficiarioNombreBeneficiario: "Nombre del Beneficiario",
      BancoBeneficiarioCuenta: "Número de Cuenta del Beneficiario",

      ref1Nombre: "Nombre Referencia Comercial 1",
      ref1Telefono: "Teléfono Referencia Comercial 1",
      ref1Correo: "Correo Referencia Comercial 1",
      ref2Nombre: "Nombre Referencia Comercial 2",
      ref2Telefono: "Teléfono Referencia Comercial 2",
      ref2Correo: "Correo Referencia Comercial 2",

      AutorizacionDeposito: "Autorización de depósito",

      NombreZonaLibre: "Nombre Zona Libre",
      DireccionZonaLibre: "Dirección Zona Libre",
      RegistroExonerado: "Registro Exonerado",
      FechaVencimiento: "Fecha de Vencimiento",
      FechaInicio: "Fecha de Inicio",

      resultArchivoBIC: "Archivo BIC: RTN/NIT/RUC/TAX ID",
      resultArchivoFactura: "Archivo de factura/orden de compra/dirección",
      resultArchivoRegistroExonerado: "Archivo de registro exonerado",
      resultArchivoConstPagosCuenta: "Archivo de constancia de pagos a cuenta",
      resultArchivoPermisoOperaciones: "Archivo de permiso de operaciones",
      resultArchivoEscrituraConstitucion: "Archivo de escritura de la constitución",
      resultArchivoCertificado: "Archivo de Pasaporte/Certificado",

      CurrencyFin: "Moneda Financiera",
      ActivosCorrientes: "Activos Corrientes",
      TotalActivos: "Total de Activos",
      PasivosCorrientes: "Pasivos Corrientes",
      TotalPasivos: "Total de Pasivos",

      size: "Tamaño de archivo excedido",
      General: '',
      Banco: "Datos bancarios",
      Documentos: "Documentos requeridos",
      ConcactoFinanzas: "Contacto de Finanzas",
      ReferenciasComerciales: "Referencias Comerciales",
      CuentasPorCobrar: "Datos Cuentas por Cobrar",
      selectedOption: "Debe seleccionar una opción de pago",
    };

    const mensajesErroresEN = {
      CustomerName: "Legal Name",
      NombreComercial: "Trade Name",
      numeroIdentificacionTributaria: "RTN/NIT/RUC/TAX ID",
      Country: "Country",
      State: "State/Province",
      City: "City",
      Address: "Address",
      Tel: "Phone",
      Email: "Email",
      PrincipalActividadEconomica: "Main Economic Activity",
      TipoFacturacion: "Billing Type",

      ContactoCuentasPorCobrar: "Accounts Receivable Contact",
      CorreoCuentasPorCobrar: "Accounts Receivable Email",
      TelefonoCuentasPorCobrar: "Accounts Receivable Phone",
      Currency: "Bank Currency",

      refFin1Nombre: "Finance Contact Name 1",
      refFin1Telefono: "Finance Contact Phone 1",
      refFin1Correo: "Finance Contact Email 1",
      refFin2Nombre: "Finance Contact Name 2",
      refFin2Telefono: "Finance Contact Phone 2",
      refFin2Correo: "Finance Contact Email 2",

      NumeroCuentaBancaria: "Bank Account Number",
      TitularCuenta: "Account Holder",
      Banco: "Bank",
      TipoCuenta: "Account Type",

      BancoBeneficiarioNombre: "Beneficiary Bank Name",
      BancoBeneficiarioAbaBin: "Beneficiary Bank ABA/BIN",
      BancoBeneficiarioDireccion: "Beneficiary Bank Address",
      BancoBeneficiarioSwift: "SWIFT Code",
      BancoBeneficiarioNombreBeneficiario: "Beneficiary Name",
      BancoBeneficiarioCuenta: "Beneficiary Account Number",

      ref1Nombre: "Commercial Reference Name 1",
      ref1Telefono: "Commercial Reference Phone 1",
      ref1Correo: "Commercial Reference Email 1",
      ref2Nombre: "Commercial Reference Name 2",
      ref2Telefono: "Commercial Reference Phone 2",
      ref2Correo: "Commercial Reference Email 2",

      AutorizacionDeposito: "Deposit Authorization",

      NombreZonaLibre: "Free Zone Name",
      DireccionZonaLibre: "Free Zone Address",
      RegistroExonerado: "Exempt Registration",
      FechaVencimiento: "Expiration Date",

      resultArchivoBIC: "BIC File: RTN/NIT/RUC/TAX ID",
      resultArchivoFactura: "Invoice/Purchase Order/Address File",
      resultArchivoRegistroExonerado: "Exempt Registration File",
      resultArchivoConstPagosCuenta: "Account Payments Proof File",
      resultArchivoPermisoOperaciones: "Operating Permit File",
      resultArchivoEscrituraConstitucion: "Constitution Deed File",
      resultArchivoCertificado: "Passport/Certificate File",

      CurrencyFin: "Financial Currency",
      ActivosCorrientes: "Current Assets",
      TotalActivos: "Total Assets",
      PasivosCorrientes: "Current Liabilities",
      TotalPasivos: "Total Liabilities",

      size: "File size exceeds the 5MB limit",
      General: '',
      Banco: "Bank Information",
      Documentos: "Required Documents",
      ConcactoFinanzas: "Finance Contact",
      ReferenciasComerciales: "Commercial References",
      CuentasPorCobrar: "Accounts Receivable",
      selectedOption: "You must select a payment option",
    };



    const listaFaltantes = Object.keys(errors).filter(key => errors[key]).map(key => (idioma === 'es' ? mensajesErrores[key] : mensajesErroresEN[key]) || '');
    setListaFaltantes(listaFaltantes, errors);

    if (listaFaltantes.length === 0 && isValid) {
      confirmDialog({
        header: setLabel('msgConfirmacion'),
        message: setLabel('msgNoEditable'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => guardarInscripcion(false),
        reject: () => {
          setLoading(false);
        }
      });

      // setShowDialog(true);
    } else {
      setShowDialogIncompleto(true);
      console.log("Errores encontrados:", errors);
      // toastShow(toast, 'warn', 'Error', 'Por favor, complete los campos requeridos');
      if (errors.size) {
        toastShow(toast, 'warn', 'Error', 'El tamaño de los archivos no puede ser mayor a 5MB');
      }
    }
  }

  const guardarInscripcion = async (Incompleta = false) => {
    setLoading(true);
    // verificarCampos();

    const userTempo = await getUsuariosActivosToken(Token);
    const usuarioActual = userTempo.find(user => user.idUser === idUser);

    let Company = { ...values };

    let FileBIC = null;
    let FileBICName = values.BICName;
    let FilePermisoOperaciones = null;
    let FileConstPagosCuenta = null;
    let FileRegistroExonerado = null;
    let FileEscrituraConstitucion = null;
    let FileFactura = null;
    let FileCertificado = null;

    Company.IdCustomer = idCustomer;
    Company.IdCountry = values?.Country?.Id;
    Company.Country = values?.Country?.Name;
    // BANCO NACIONAL
    Company.IdPaisCuentaBancaria = values?.PaisCuentaBancaria?.Id
    Company.PaisCuentaBancaria = values?.PaisCuentaBancaria?.Name
    Company.Currency = values?.Currency?.IdCurrency;

    Company.CurrencyFin = values?.CurrencyFin?.IdCurrency;
    Company.Token = Token;
    Company.FechaLlenoFormato = getDateTimeStringSQL24(new Date())

    FileEscrituraConstitucion = resultArchivoEscrituraConstitucion;


    if ((values?.PaisCuentaBancaria?.Id || values?.IdPaisCuentaBancaria) === IdHonduras) {
      Company.NumeroCuentaBancaria = values?.NumeroCuentaBancaria;
      Company.TitularCuenta = values?.TitularCuenta;
      Company.IdBanco = values?.Banco?.IdBanco;
      Company.Banco = values?.Banco?.NombreBanco;
      Company.TipoCuenta = values?.TipoCuenta?.tipo;

      Company.BancoIntermediarioNombre = null;
      Company.BancoIntermediarioDireccion = null;
      Company.BancoIntermediarioSwift = null;
      Company.BancoIntermediarioAbaBin = null;
      Company.BancoIntermediarioCuenta = null;
      // BANCO BENEFICIARIO
      Company.BancoBeneficiarioNombre = null;
      Company.BancoBeneficiarioDireccion = null;
      Company.BancoBeneficiarioSwift = null;
      Company.BancoBeneficiarioNombreBeneficiario = null;
      Company.BancoBeneficiarioCuenta = null;
      Company.BancoBeneficiarioAbaBin = null;

      // DOCUMENTOS
      FileBIC = resultArchivoBIC;
      FilePermisoOperaciones = resultArchivoPermisoOperaciones;


      FileFactura = resultArchivoFactura;
      FileCertificado = resultArchivoCertificado;
      Company.CertificadoName = values?.CertificadoName;

      if (ArchivoSelected === 0) {
        FileConstPagosCuenta = resultArchivoConstPagosCuenta;
        Company.ConstPagosName = values?.ConstPagosName;
        FileRegistroExonerado = null;
        Company.RegistroExoneradoName = null;
      } else {
        FileConstPagosCuenta = null;
        Company.ConstPagosName = null;
        FileRegistroExonerado = resultArchivoRegistroExonerado;
      }
    } else {
      // BANCOS EXTRAJEROS
      // BANCO INTERMEDIARIO
      Company.BancoIntermediarioNombre = values?.BancoIntermediarioNombre;
      Company.BancoIntermediarioDireccion = values?.BancoIntermediarioDireccion;
      Company.BancoIntermediarioSwift = values?.BancoIntermediarioSwift;
      Company.BancoIntermediarioAbaBin = values?.BancoIntermediarioAbaBin;
      Company.BancoIntermediarioCuenta = values?.BancoIntermediarioCuenta;
      // BANCO BENEFICIARIO
      Company.BancoBeneficiarioNombre = values?.BancoBeneficiarioNombre;
      Company.BancoBeneficiarioDireccion = values?.BancoBeneficiarioDireccion;
      Company.BancoBeneficiarioSwift = values?.BancoBeneficiarioSwift;
      Company.BancoBeneficiarioNombreBeneficiario =
        values?.BancoBeneficiarioNombreBeneficiario;
      Company.BancoBeneficiarioCuenta = values?.BancoBeneficiarioCuenta;
      Company.BancoBeneficiarioAbaBin = values?.BancoBeneficiarioAbaBin;

      Company.NumeroCuentaBancaria = null;
      Company.TitularCuenta = null;
      Company.IdBanco = null;
      Company.Banco = null;
      Company.TipoCuenta = null;

      // DOCUMENTOS
      FileBIC = resultArchivoBIC;
      FileFactura = resultArchivoFactura;
      FileCertificado = resultArchivoCertificado;
      FilePermisoOperaciones = null;
      FileConstPagosCuenta = null;
      FileRegistroExonerado = null;
      // FileEscrituraConstitucion = null;
    }

    // ZONA LIBRE
    if (ArchivoSelected === 1) {
      Company.ZonaLibre = true;
      Company.NombreZonaLibre = values?.NombreZonaLibre;
      Company.DireccionZonaLibre = values?.DireccionZonaLibre;
      Company.RegistroExonerado = values?.RegistroExonerado;

      Company.IdRegistro = values?.IdRegistro ?? null;

      Company.FechaVencimiento = values?.FechaVencimiento;
      Company.FechaInicio = values?.FechaInicio;
      Company.NombreZona = values?.NombreZona;
      Company.DireccionZona = values?.DireccionZona;
      Company.Zoli = values?.ZonaLibre;
      Company.RegistroExoneradoName = values?.RegistroExoneradoName;
      Company.SinRegistroExonerado = values?.SinRegistroExonerado;
      if (!resultArchivoRegistroExonerado) {
        const a = await getArchivo(values?.IdCustomer, Token);
        Company.RegistroExoneradoArchivo = a?.[0]?.Archivo;
      } else {
        Company.RegistroExoneradoArchivo = resultArchivoRegistroExonerado;
      }
    } else {
      Company.IdRegistro = values?.IdRegistro ?? null;
      Company.ZonaLibre = false;
      Company.NombreZonaLibre = null;
      Company.DireccionZonaLibre = null;
      Company.ConstPagosName = values?.ConstPagosName;
      Company.FileConstPagosCuenta = resultArchivoConstPagosCuenta;
      Company.TieneConstPagosCuenta = values?.TieneConstPagosCuenta;
    }

    Company.TipoFacturacion = values?.TipoFacturacion?.tipo;
    Company.AutorizacionDeposito = values?.AutorizacionDeposito ? 1 : 0;
    Company.ArchivoPermisoOperaciones = resultArchivoPermisoOperaciones;
    Company.ArchivoBIC = resultArchivoBIC;
    Company.Contact = null;
    Company.esEditable = Incompleta === true ? 1 : 0;
    Company.Incompleta = Incompleta;
    Company.DeduccionACH = values?.selectedOption === 'DeduccionACH' ? true : false;
    Company.PagarCheque = values?.selectedOption === 'PagarCheque' ? true : false;


    if (FileBIC) {
      await saveArchivoBIC(FileBIC, idCustomer, FileBICName, Token);
    }
    if (FilePermisoOperaciones) {
      await saveArchivoPermisoOperaciones(
        FilePermisoOperaciones,
        idCustomer,
        values.PermisoOperacionesName,
        Token
      );
    }
    if (FileConstPagosCuenta) {
      await saveArchivoConstanciaPagos(
        FileConstPagosCuenta,
        idCustomer,
        values.ConstPagosName,
        Token
      );
    }
    if (FileRegistroExonerado) {
      await saveArchivoRegistroDexonera(
        FileRegistroExonerado,
        idCustomer,
        values.RegistroExoneradoName,
        Token
      );
    }

    if (FileEscrituraConstitucion) {

      await saveArchivoEscrituraConstitucion(
        FileEscrituraConstitucion,
        idCustomer,
        values.EscrituraConstitucionName,
        Token
      );
    }

    if (FileFactura) {
      await saveArchivoFactura(
        FileFactura,
        idCustomer,
        values?.FacturaName,
        Token
      );
    }

    if (FileCertificado) {
      await saveArchivoCertificado(
        FileCertificado,
        idCustomer,
        values?.CertificadoName,
        Token
      );
    }

    const result = await saveInscripcionProveedor(Company, Token);

    if (result?.length > 0) {
      await finalizarSolicitudEdicion(); 
      if (listaCorreos.length > 0) {
        if (!Incompleta) {
          const correoInfo = listaCorreos[0];
          EnviarCorreo({
            setLoadingCorreo: setLoading,
            toast,
            showToas: false,
            contenido: `
                  <p>Se ha completado el registro del proveedor:</p>
                  <p><strong>Código:</strong> ${formatCodigoProveedor(
              idCustomer
            )}<br/>
                  <strong>Nombre:</strong> ${Company.CustomerName}</p>
                  <br/>
                  <br/>
                  <p style="font-size: 13px; color: gray;">Mensaje autogenerado, favor no responderlo.</p>
                `,
            to: [usuarioActual?.Mail, correoInfo.DestinatariosMail].filter(Boolean).join(','),
            cc: correoInfo.CCMail,
            bcc: correoInfo.CCoMail,
            subject: correoInfo.Asunto,
            attachments: null,
          });
          setEditable(false);
          setEditable2(false);
          toastShow(toast, "success", setLabel("registroCompleto"));

          setTimeout(() => {
            navigate(`/web/Confirmacion/${idioma}`);
          }, 2000);
        } else {
          confirmDialog({
            message: setLabel("msgIncompleta"),
            header: setLabel("InformacionGuardada"),
            icon: "pi pi-exclamation-triangle",
            acceptClassName: "hidden",
            rejectClassName: "p-button-secondary",
            rejectLabel: setLabel("Cerrar"),
          })
          setShowDialogIncompleto(false);

          // setTimeout(() => {
          //   navigate(`/web/Confirmacion/${idioma}`);
          // }, 3000);
        }
      }
    } else {
      toastShow(toast, "error", setLabel("errorRegistro"));
    }
    setLoading(false);
  };

  const finalizarSolicitudEdicion = async () => {
    if (tieneSolicitud && values.IdEstadoSolicitud === 3118) {
      if (solicitudEdicionActiva?.HabilitarPago) {
        return;
      } else {
        const payload = [{
          IdSolicitudEdicion: values.IdSolicitudEdicion,
          IdEstado: 3119,
          DateEdit: getDateTimeStringSQL24(new Date())
        }];

        await FinalizarSolicitudEdicion(payload, Token);
      }
    }
  };

  //VerifiXAR Campos Exonerados
  const verificarRegistroExonerado = () => {
    let errors = {};
    let isValid = true;
    if (!values.SinRegistroExonerado) {
      if (!values?.FechaVencimiento) {
        errors.FechaVencimiento = true;
        isValid = false;
      }

      if (!values?.FechaInicio) {
        errors.FechaInicio = true;
        isValid = false;
      }

      if (values.FechaVencimiento < values.FechaInicio) {
        errors.FechaInicio = true;
        errors.Documentos = true;
        isValid = false;
      }
    }
    if (!values?.SinRegistroExonerado && ArchivoSelected === 1) {
      // if (!values?.ZonaLibre) {
      //   console.log('ZonaLibre')
      //   errors.Zoli = true;
      //   isValid = false;
      // }

      if (!values?.RegistroExonerado || values.RegistroExonerado.trim() === '') {

        errors.RegistroExonerado = true;
        isValid = false;
      }


      if (!values?.NombreZonaLibre || values.NombreZonaLibre.trim() === '') {

        errors.NombreZonaLibre = true;
        isValid = false;
      }

      if (!values?.DireccionZonaLibre || values.DireccionZonaLibre.trim() === '') {

        errors.DireccionZonaLibre = true;
        isValid = false;
      }

      if (!ArchivoRegistroExonerado && !resultArchivoRegistroExonerado) {
        console.log('ArchivoRegistroExonerado')
        errors.resultArchivoRegistroExonerado = true;
        isValid = false;
      }
    }



    // Mostrar errores
    setShowMessages({ ...errors, error: !isValid });

    if (!isValid) {
      toastShow(toast, 'warn', 'Error', 'Por favor complete los campos requeridos');
      if (errors.size) {
        toastShow(toast, 'warn', 'Error', 'El tamaño del archivo excede los 5MB');
      }
    }

    return isValid;
  };

  //Agregar Registro Exonerado
  const addRegistro = async () => {
    const isValid = verificarRegistroExonerado();
    if (!isValid) return;
    const userTempo = await getUsuariosActivosToken(Token);
    const usuarioActual = userTempo.find(user => user.idUser === idUser);
    setLoading(true);

    let datosEnviar

    let archivoBase64 = null, archivoConstancia = null;
    if (resultArchivoRegistroExonerado instanceof Uint8Array) {
      archivoBase64 = uint8ArrayToBase64(resultArchivoRegistroExonerado);
    }

    if (resultArchivoConstPagosCuenta instanceof Uint8Array) {
      archivoConstancia = uint8ArrayToBase64(resultArchivoConstPagosCuenta);
    }

    if (ArchivoSelected === 1) {

      datosEnviar = {
        IdRegistro: values?.IdRegistro,
        IdProveedor: values?.IdCustomer,
        Zoli: true,
        RegistroExonerado: values?.RegistroExonerado,
        FechaVencimiento: values?.FechaVencimiento,
        FechaInicio: values?.FechaInicio,
        NombreZona: values?.NombreZonaLibre,
        DireccionZona: values?.DireccionZonaLibre,
        RegistroExoneradoName: values?.RegistroExoneradoName,
        RegistroExoneradoArchivo: archivoBase64,
        SinRegistroExonerado: values?.SinRegistroExonerado,
      };

    } else {
      datosEnviar = {
        IdRegistro: values?.IdRegistro,
        IdProveedor: values?.IdCustomer,
        Zoli: false,
        RegistroExonerado: null,
        FechaVencimiento: values?.FechaVencimiento,
        FechaInicio: values?.FechaInicio,
        NombreZona: null,
        DireccionZona: null,
        RegistroExoneradoName: null,
        RegistroExoneradoArchivo: null,
        TieneConstPagosCuenta: values?.TieneConstPagosCuenta,
        SinRegistroExonerado: values?.SinRegistroExonerado,
        ConstPagosName: values?.ConstPagosName,
        FileConstPagosCuenta: resultArchivoConstPagosCuenta

      };
    }
    //  const actualizarInformacionProveedor = {
    //     IdCustomer: values?.IdCustomer,
    //     SinRegistroExonerado: values?.SinRegistroExonerado,
    //     ZonaLibre: ArchivoSelected ===  1 ?  true : false//values?.ZonaLibre

    //   }

    const info = await saveRegistroExonerado(datosEnviar, Token);

    await saveArchivoRegistroDexonera(resultArchivoRegistroExonerado, idCustomer, values?.RegistroExoneradoName, Token);
    await await saveArchivoConstanciaPagos(resultArchivoConstPagosCuenta, idCustomer, values.ConstPagosName, Token);

    if (info[0]?.ESTADO === 1) {

      setEditable(false);
      setEditable2(false);
      setBotonRegistro(false);
      toastShow(toast, 'success', 'Éxito', setLabel(info.MENSAJE));
      if (!values.SinRegistroExonerado) {
        if (listaCorreos.length > 0) {
          const correoInfo = listaCorreos[0];
          EnviarCorreo({
            setLoadingCorreo: setLoading,
            toast,
            showToas: false,
            contenido: `
                <p>Se ha agregago un nuevo Registro exonerado al proveedor:</p>
                <p><strong>Código:</strong> ${formatCodigoProveedor(idCustomer)}<br/>
                <strong>Nombre:</strong> ${values.CustomerName}</p>
                <br/>
                <br/>
                <p style="font-size: 13px; color: gray;">Mensaje autogenerado, favor no responderlo.</p>
              `,
            to: [usuarioActual?.Mail, correoInfo.DestinatariosMail].filter(Boolean).join(','),
            cc: correoInfo.CCMail,
            bcc: correoInfo.CCoMail,
            subject: correoInfo.Asunto,
            attachments: null
          });
        }

      }
      setTimeout(() => {
        navigate(`/web/Confirmacion/${idioma}`);
      }, 500);
    }
    setLoading(false);
  }

  const uint8ArrayToBase64 = (u8Arr) => {
    const CHUNK_SIZE = 0x8000;
    let index = 0;
    const length = u8Arr.length;
    let result = '';
    let slice;
    while (index < length) {
      slice = u8Arr.subarray(index, Math.min(index + CHUNK_SIZE, length));
      result += String.fromCharCode.apply(null, slice);
      index += CHUNK_SIZE;
    }
    return btoa(result);
  }

  const setLabel = (label) => {
    return getLabel(InscripcionProveedoresLang, label, idioma);
  }

  const descargarArchivo = async (archivo, name) => {
    const File = await getArchivoProveedor(archivo, idCustomer, Token);
    if (File.length > 0) {
      downloadBase64Data({ Data: File[0]?.Archivo, Tipo: File[0]?.Name })
    }
  }

  const uploadFormatoInscripcion = async (Archivo) => {
    if (Archivo) {
      ArchivoConvertSQL(Archivo, async (result) => {
        if (result) {
          await saveArchivoFormatoInscripcion(result, idCustomer, Archivo.name, Token);
          toastShow(toast, 'success', setLabel('archivoGuardado'));
          getCompanyInfo(idCustomer)
        }
      });
    }
  }

  const descargarFormatoinscripcion = async () => {
    const File = await getArchivoFormatoInscripcion(idCustomer, Token);
    if (File.length > 0) {
      downloadBase64Data({ Data: File[0]?.Archivo, Tipo: File[0]?.Name })
    }
  }


  useEffect(() => {
    getInfo();
    setIdioma(lang);
    document.title = 'PPF - ' + setLabel('Titulo');


    const html = document.querySelector('html');
    html.setAttribute('lang', lang);

    const decoded = decodeToken(Token);
    if (decoded) {
      setTokenInfo(decoded);
      let { IdCustomer } = decoded;
      if (IdCustomer) {
        setIdCustomer(IdCustomer);
        getCompanyInfo({ IdCustomer });
        obtenerSolicitudEdicionActiva(IdCustomer);
      } else {
      }
    } else {
    }
    setInitializing(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (ArchivoBIC) {
      if (ArchivoBIC.size < 5 * 1024 * 1024) {
        ArchivoConvertSQL(ArchivoBIC, setResultArchivoBIC);
        handleInputChange({ target: { name: 'BICName', value: ArchivoBIC.name } });
      } else {
        toastShow(toast, 'error', setLabel('ErrorArchivoTamaño'));
        setResultArchivoBIC(null);
        handleInputChange({ target: { name: 'BICName', value: null } });
        setArchivoBIC(null);
        setShowMessages({ ...showMessages, resultArchivoBIC: true, size: true, value: true, error: false });
      }
    } else {
      setResultArchivoBIC(null);
      handleInputChange({ target: { name: 'BICName', value: null } });
    }
  }, [ArchivoBIC])

  useEffect(() => {
    if (ArchivoPermisoOperaciones) {
      if (ArchivoPermisoOperaciones.size < 5 * 1024 * 1024) {
        ArchivoConvertSQL(ArchivoPermisoOperaciones, setResultArchivoPermisoOperaciones);
        handleInputChange({ target: { name: 'PermisoOperacionesName', value: ArchivoPermisoOperaciones.name } });
      } else {
        toastShow(toast, 'error', setLabel('ErrorArchivoTamaño'));
        setResultArchivoPermisoOperaciones(null);
        handleInputChange({ target: { name: 'BICName', value: null } });
        setArchivoPermisoOperaciones(null);
        setShowMessages({ ...showMessages, resultArchivoPermisoOperaciones: true, size: true, value: true, error: false });
      }
    } else {
      setResultArchivoPermisoOperaciones(null);
      handleInputChange({ target: { name: 'PermisoOperacionesName', value: null } });
    }
  }, [ArchivoPermisoOperaciones])

  useEffect(() => {
    if (ArchivoRegistroExonerado) {
      if (ArchivoRegistroExonerado.size < 5 * 1024 * 1024) {
        ArchivoConvertSQL(ArchivoRegistroExonerado, setResultArchivoRegistroExonerado);
        handleInputChange({ target: { name: 'ConstPagosName', value: null } });
        handleInputChange({ target: { name: 'RegistroExoneradoName', value: ArchivoRegistroExonerado.name } });
      } else {
        toastShow(toast, 'error', setLabel('ErrorArchivoTamaño'));
        setResultArchivoRegistroExonerado(null);
        handleInputChange({ target: { name: 'ConstPagosName', value: null } });
        setArchivoRegistroExonerado(null);
        setShowMessages({ ...showMessages, resultArchivoRegistroExonerado: true, size: true, value: true, error: false });
      }
    } else {
      setResultArchivoRegistroExonerado(null);
      handleInputChange({ target: { name: 'RegistroExoneradoName', value: null } });
    }
  }, [ArchivoRegistroExonerado])


  useEffect(() => {
    if (ArchivoConstPagosCuenta) {
      if (ArchivoConstPagosCuenta.size < 5 * 1024 * 1024) {
        ArchivoConvertSQL(ArchivoConstPagosCuenta, setResultArchivoConstPagosCuenta);
        handleInputChange({ target: { name: 'RegistroExoneradoName', value: null } });
        handleInputChange({ target: { name: 'ConstPagosName', value: ArchivoConstPagosCuenta.name } });
      } else {
        toastShow(toast, 'error', setLabel('ErrorArchivoTamaño'));
        setResultArchivoConstPagosCuenta(null);
        handleInputChange({ target: { name: 'ConstPagosName', value: null } });
        setArchivoConstPagosCuenta(null);
        setShowMessages({ ...showMessages, resultArchivoConstPagosCuenta: true, size: true, value: true, error: false });
      }
    } else {
      setResultArchivoConstPagosCuenta(null);
      handleInputChange({ target: { name: 'ConstPagosName', value: null } });
    }
  }, [ArchivoConstPagosCuenta])


  useEffect(() => {
    if (ArchivoFactura) {
      if (ArchivoFactura.size < 5 * 1024 * 1024) {
        ArchivoConvertSQL(ArchivoFactura, setResultArchivoFactura);
        handleInputChange({ target: { name: 'FacturaName', value: ArchivoFactura.name } });
      } else {
        toastShow(toast, 'error', setLabel('ErrorArchivoTamaño'));
        setResultArchivoFactura(null);
        handleInputChange({ target: { name: 'FacturaName', value: null } });
        setArchivoFactura(null);
        setShowMessages({ ...showMessages, resultArchivoFactura: true, size: true, value: true, error: false });
      }
    } else {
      setResultArchivoConstPagosCuenta(null);
      handleInputChange({ target: { name: 'FacturaName', value: null } });
    }
  }, [ArchivoFactura])

  useEffect(() => {
    if (ArchivoEscrituraConstitucion) {
      if (ArchivoEscrituraConstitucion.size < 10 * 1024 * 1024) {
        ArchivoConvertSQL(ArchivoEscrituraConstitucion, setResultArchivoEscrituraConstitucion);
        handleInputChange({ target: { name: 'EscrituraConstitucionName', value: ArchivoEscrituraConstitucion.name } });
      } else {
        toastShow(toast, 'error', setLabel('ErrorArchivoTamaño'));
        setResultArchivoEscrituraConstitucion(null);
        handleInputChange({ target: { name: 'EscrituraConstitucionName', value: null } });
        setArchivoEscrituraConstitucion(null);
        setShowMessages({ ...showMessages, setResultArchivoEscrituraConstitucion: true, size: true, value: true, error: false });
      }
    } else {
      setResultArchivoEscrituraConstitucion(null);
      handleInputChange({ target: { name: 'EscrituraConstitucionName', value: null } });
    }
  }, [ArchivoEscrituraConstitucion]);

  useEffect(() => {
    if (ArchivoCertificado) {
      if (ArchivoCertificado.size < 5 * 1024 * 1024) {
        ArchivoConvertSQL(ArchivoCertificado, setResultArchivoCertificado);
        handleInputChange({ target: { name: 'CertificadoName', value: ArchivoCertificado.name } });
      } else {
        toastShow(toast, 'error', setLabel('ErrorArchivoTamaño'));
        setResultArchivoCertificado(null);
        handleInputChange({ target: { name: 'CertificadoName', value: null } });
        setArchivoCertificado(null);
        setShowMessages({ ...showMessages, resultArchivoCertificado: true, size: true, value: true, error: false });
      }
    } else {
      setResultArchivoCertificado(null);
      handleInputChange({ target: { name: 'CertificadoName', value: null } });
    }

  }, [ArchivoCertificado])

  const limpiarZonaLibre = () => {
    setEditable2(true);
    setValues(prev => ({
      ...prev,
      IdRegistro: null,
      RegistroExonerado: '',
      FechaVencimiento: null,
      FechaInicio: null,
      NombreZonaLibre: '',
      DireccionZonaLibre: '',
      IdEstadoExonerado: null,
      resultArchivoRegistroExonerado: null,
      SinRegistroExonerado: false
    }));
    // if(!editable){
    setBotonRegistro(true);
    // }
  };

  const limpiarConstanciaPagos = () => {
    setEditable2(true);
    setValues(prev => ({
      ...prev,
      FechaVencimiento: null,
      FechaInicio: null,
    }));
    // if(!editable){
    setBotonRegistro(true);
    // }
  };

  const isFormEditable = () => {
    if (values.IdStatusRevision === 3723) {
      return false;
    }
    if (values.IdStatusRevision === 3722 || values.idSolicitudEdicion || values.IdEstadoSolicitud === 3118) {
      return true;
    }
    return editable;
  };

  const zonaLibreDeshabilitada = values?.IdEstadoExonerado === 3727;
  
  const tieneSolicitud = values.IdSolicitudEdicion != null;

  const isFieldEditable = (section) => {
    if (values.IdStatusRevision === 3722) {
      return true
    } else {
      if (values.IdStatusRevision === 3741 && (values.idSolicitudEdicion || values.IdEstadoSolicitud === 3118)) {
        if (section && values[section] === true) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }
  
  const mensajeFaltantes = (
    <div>
      <p>{setLabel('msgNoEditableIncompleta')}</p>
      <strong>{setLabel('InformacionFaltante')}:</strong>
      <div>
        <ul>
          {listaFaltantes?.map((item, index) => (
            item !== '' ? <li key={index} className="mx-4">
              <span style={{ color: 'red' }}>-</span> {item}
            </li> : null
          ))}
        </ul>
      </div>
    </div>
  );

  const footerDialog = (
    <React.Fragment>
      <Button
        label={setLabel('no')}
        icon="pi pi-times"
        onClick={() => {
          setShowDialogIncompleto(false)
        }}
      />
      <Button
        label={setLabel('guardarBorrador')}
        icon="pi pi-check"
        className="p-button-success"
        onClick={() => guardarInscripcion(true)}
      />
    </React.Fragment>
  );

  const handleInputChange2 = (e, fieldName) => {
    setValues(prevValues => ({
      ...prevValues,
      selectedOption: fieldName
    }));
  };


  if (initializing) return null;
  if (tokenInfo) {
    return (
      <div id='inscripcion'>

        <Loader loading={loading} querySelector='#inscripcion' />
        <Toast position="bottom-right" ref={toast} />

        <div className='ProveedoreInfoContainer'>
          <ConfirmDialog />
          <div className='col-12'>
            <div className='header'>
              <div className="columna">
                <div>
                  <h1 style={{ color: colorTexto }}>{setLabel('Titulo')}</h1>
                  <h5 style={{ color: colorTexto }}>{setLabel('codigoProveedor')}: {formatCodigoProveedor(idCustomer)}</h5>
                  {userAuth?.idUser ?
                    <div className='d-flex gap'>
                      <div style={{ width: 150, alignContent: 'center' }}>
                        <Tag value={values?.StatusRevision} className={`status-${values?.IdStatusRevision}`} style={{ height: 40 }} />
                      </div>
                      <div className='d-flex flex-column'>
                        <span style={{ color: colorTexto }}> {values?.UsuarioReviso ? (`Revisado: ` + values?.UsuarioReviso + ' - ' + values.FechaRevision) : ''}</span>
                        <span style={{ color: colorTexto }}> {values?.UserRevisoFinanzas ? (`Revisado Finanzas: ` + values?.UserRevisoFinanzas + ' - ' + values.FinanceReviewDate) : ''}</span>
                        <span style={{ color: colorTexto }}> {values?.FechaLlenoFormato ? (`Fecha Lleno Formato: ` + getDateTimeString(new Date(values?.FormatDate))) : ''}</span>
                      </div>
                    </div>
                    : null
                  }
                </div>
                {config.theme !== 'light' ? <img src={"https://were.ppf.com.hn/assets/Logo_PPF_PrimarioH.png"} alt="Imagen" className="logo" /> :
                  <img src={"https://were.ppf.com.hn/assets/Logo_PPF_Primario Negro_H.png"} alt="Imagen" className="logo" />}
              </div>
              <div className='switchIdioma' >
                <SelectButton value={idioma} options={[{ label: 'English', value: 'en' }, { label: 'Español', value: 'es' }]} onChange={(e) => setIdioma(e.value ? e.value : 'es')} />
                <div className='mx-3'>
                  <Button
                    text={config.theme === 'Light'}
                    icon='pi pi-sun'
                    tooltip='Light'
                    onClick={e => {
                      changeTheme('Light')
                    }}
                    severity={config.theme === 'Light' ? 'primary' : 'secondary'}
                  />
                  <Button
                    text={config.theme === 'Dark'}
                    icon='pi pi-moon'
                    tooltip='Dark'
                    onClick={e => {
                      changeTheme('Dark')
                    }}
                    severity={config.theme === 'Dark' ? 'primary' : 'secondary'}
                  />
                </div>
              </div>
            </div>

            <div className="">
              {/* INFORMACION DE LA EMPRESA */}
              <Card
                titulo={setLabel('informacionEmpresaTitle')}
                contenido={(
                  <div>
                    <div className="inputsProveedorContainer" >
                      {/* Nombre Comercial (Si es distinto al nombre de la casa matriz) */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values?.CustomerName}
                            onChange={(e) => handleInputChange(e, 'CustomerName')}
                            className={classNames({ 'p-invalid': showMessages?.CustomerName })}
                            tooltip={values?.CustomerName} tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionEmpresa')}
                            style={!isFieldEditable('InformacionEmpresa') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('NombreLegal')}</label>
                        </div>
                      </div>

                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values?.NombreComercial}
                            onChange={(e) => handleInputChange(e, 'NombreComercial')}
                            className={classNames({ 'p-invalid': showMessages?.NombreComercial })}
                            tooltip={!editable ? values?.NombreComercial : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionEmpresa')}
                            style={!isFieldEditable('InformacionEmpresa') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('NombreComercial')}</label>
                        </div>
                      </div>

                      {/* Número de Identificación Tributaria RTN/RUC/UTR/BRN */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values?.numeroIdentificacionTributaria}
                            onChange={(e) => handleInputChange(e, 'numeroIdentificacionTributaria')}
                            className={classNames({ 'p-invalid': showMessages?.numeroIdentificacionTributaria })}
                            tooltip={!editable ? values?.numeroIdentificacionTributaria : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionEmpresa')}
                            style={!isFieldEditable('InformacionEmpresa') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('NumIdentificacionTributaria')}</label>
                        </div>
                        <small>RTN/RUC/UTR/BRN</small>
                      </div>

                      {/* PAIS */}
                      <div>
                        <AutoCompleteDropdown
                          name={'Country'}
                          value={values.Country}
                          label={setLabel('Pais')}
                          items={Countries}
                          field={'Name'}
                          handleInputChange={handleInputChange}
                          className={classNames({ 'p-invalid': showMessages?.Country })}
                          enable={isFieldEditable('InformacionEmpresa')} 
                        />
                      </div>

                      {/* ESTADO*/}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values?.State}
                            onChange={(e) => handleInputChange(e, 'State')}
                            className={classNames({ 'p-invalid': showMessages?.State })}
                            tooltip={!editable ? values?.State : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionEmpresa')}
                            style={!isFieldEditable('InformacionEmpresa') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('Estado')}</label>
                        </div>
                      </div>

                      {/* CIUDAD*/}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values?.City}
                            onChange={(e) => handleInputChange(e, 'City')}
                            className={classNames({ 'p-invalid': showMessages?.City })}
                            tooltip={!editable ? values?.City : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionEmpresa')}
                            style={!isFieldEditable('InformacionEmpresa') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('Ciudad')}</label>
                        </div>
                      </div>



                      {/* Direccion Comercial */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values?.Address}
                            onChange={(e) => handleInputChange(e, 'Address')}
                            className={classNames({ 'p-invalid': showMessages?.Address })}
                            tooltip={!editable ? values?.Address : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionEmpresa')}
                            style={!isFieldEditable('InformacionEmpresa') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('Direccion')}</label>
                        </div>
                      </div>

                      {/* Número de teléfono de referencia */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values?.Tel}
                            onChange={(e) => handleInputChange(e, 'Tel')}
                            className={classNames({ 'p-invalid': showMessages?.Tel })}
                            tooltip={!editable ? values?.Tel : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionEmpresa')}
                            style={!isFieldEditable('InformacionEmpresa') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('TelefonoRef')}</label>
                        </div>
                      </div>


                      {/* Correo electrónico */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values?.Email}
                            onChange={(e) => handleInputChange(e, 'Email')}
                            className={classNames({ 'p-invalid': showMessages?.Email })}
                            tooltip={!editable ? values?.Email : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionEmpresa')}
                            style={!isFieldEditable('InformacionEmpresa') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('Email')}</label>
                        </div>
                      </div>

                      {/* Principal actividad económica */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values?.PrincipalActividadEconomica}
                            onChange={(e) => handleInputChange(e, 'PrincipalActividadEconomica')}
                            className={classNames({ 'p-invalid': showMessages?.PrincipalActividadEconomica })}
                            tooltip={!editable ? values?.PrincipalActividadEconomica : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionEmpresa')}
                            style={!isFieldEditable('InformacionEmpresa') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('actividadEconomica')}</label>
                        </div>
                      </div>

                      {/* Tipo de Factura, Ocultar si es Distinto a Hpnduras */}
                      {values.Country?.Id === 95 && (
                        <div>
                          <AutoCompleteDropdown
                            name={'TipoFacturacion'}
                            value={values.TipoFacturacion}
                            label={setLabel('TipoFacturacion')}
                            items={tiposFactura}
                            field={idioma === 'es' ? 'tipo' : 'type'}
                            handleInputChange={handleInputChange}
                            className={classNames({ 'p-invalid': showMessages?.TipoFacturacion })}
                            // enable={editable}
                            enable={isFieldEditable('InformacionEmpresa')} 
                          />
                        </div>
                      )}

                      {/* Nombre de la casa matriz */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values?.CasaMatriz}
                            onChange={(e) => handleInputChange(e, 'CasaMatriz')}
                            className={classNames({ 'p-invalid': showMessages?.CasaMatriz })}
                            tooltip={!editable ? values?.CasaMatriz : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionEmpresa')}
                            style={!isFieldEditable('InformacionEmpresa') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('nombreCasaMatriz')}</label>
                        </div>
                        <small>{setLabel('distCasaMatriz')}</small>
                      </div>


                      {/* Dirección de la casa matriz */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values?.DireccionCasaMatriz}
                            onChange={(e) => handleInputChange(e, 'DireccionCasaMatriz')}
                            className={classNames({ 'p-invalid': showMessages?.DireccionCasaMatriz })}
                            tooltip={!editable ? values?.DireccionCasaMatriz : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionEmpresa')}
                            style={!isFieldEditable('InformacionEmpresa') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('direccionCasaMatriz')}</label>
                        </div>
                        <small>{setLabel('distDireccionComercial')}</small>
                      </div>
                    </div>
                    {/* MENSAJES DE ERROR */}
                    {showMessages.General && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}
                  </div>
                )}
              />

              {/* INFORMACION DE CONTACTO REPRESENTANTE LEGAL */}
              <Card
                titulo={setLabel('informacionContactoRepresentanteLegal')}
                contenido={(
                  <div>
                    <div className="inputsProveedorContainer" >
                      {/* Nombre del representante legal */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.NombreRepresentanteLegal}
                            onChange={(e) => handleInputChange(e, 'NombreRepresentanteLegal')}
                            className={classNames({ 'p-invalid': showMessages?.NombreRepresentanteLegal })}
                            tooltip={!editable ? values?.NombreRepresentanteLegal : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionContacto')}
                            style={!isFieldEditable('InformacionContacto') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('Nombre')}</label>
                        </div>
                      </div>

                      {/* Correo electrónico */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.CorreoRepresentanteLegal}
                            onChange={(e) => handleInputChange(e, 'CorreoRepresentanteLegal')}
                            className={classNames({ 'p-invalid': showMessages?.CorreoRepresentanteLegal })}
                            tooltip={!editable ? values?.CorreoRepresentanteLegal : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionContacto')}
                            style={!isFieldEditable('InformacionContacto') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('Email')}</label>
                        </div>
                      </div>

                    </div>
                    {/* MENSAJES DE ERROR */}
                    {showMessages.RepresentanteLegal && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}
                  </div>
                )}
              />

              {/* INFORMACION DE CONTACTO CUENTAS POR COBRAR */}
              <Card
                titulo={setLabel('inforamcionContactoCuentasCobrar')}
                contenido={(
                  <div>
                    <div className="inputsProveedorContainer" >
                      {/* Contacto de cuentas por cobrar (Nombre) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.ContactoCuentasPorCobrar}
                            onChange={(e) => handleInputChange(e, 'ContactoCuentasPorCobrar')}
                            className={classNames({ 'p-invalid': showMessages?.ContactoCuentasPorCobrar })}
                            tooltip={!editable ? values?.ContactoCuentasPorCobrar : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionContacto')}
                            style={!isFieldEditable('InformacionContacto') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('Nombre')}</label>
                        </div>
                      </div>

                      {/* Correo electrónico (cuentas por cobrar) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.CorreoCuentasPorCobrar}
                            onChange={(e) => handleInputChange(e, 'CorreoCuentasPorCobrar')}
                            className={classNames({ 'p-invalid': showMessages?.CorreoCuentasPorCobrar })}
                            tooltip={!editable ? values?.CorreoCuentasPorCobrar : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionContacto')}
                            style={!isFieldEditable('InformacionContacto') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('Email')}</label>
                        </div>
                      </div>

                      {/* Número de teléfono */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.TelefonoCuentasPorCobrar}
                            onChange={(e) => handleInputChange(e, 'TelefonoCuentasPorCobrar')}
                            className={classNames({ 'p-invalid': showMessages?.TelefonoCuentasPorCobrar })}
                            tooltip={!editable ? values?.TelefonoCuentasPorCobrar : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionContacto')}
                            style={!isFieldEditable('InformacionContacto') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('numeroTelefono')}</label>
                        </div>
                      </div>
                    </div>
                    {/* MENSAJES DE ERROR */}
                    {showMessages.CuentasPorCobrar && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}
                  </div>

                )} />

              {/* INFORMACION DE CONTACTO FINANZAS */}
              <Card
                titulo={setLabel('inforamcionContactoFinanzas')}
                contenido={(
                  <div>
                    <div>{setLabel('Contacto')} 1</div>
                    <div className="inputsProveedorContainer" >
                      {/* Contacto de cuentas por cobrar (Nombre) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.refFin1Nombre}
                            onChange={(e) => handleInputChange(e, 'refFin1Nombre')}
                            className={classNames({ 'p-invalid': showMessages?.refFin1Nombre })}
                            tooltip={!editable ? values?.refFin1Nombre : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionContacto')}
                            style={!isFieldEditable('InformacionContacto') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('Nombre')}</label>
                        </div>
                      </div>

                      {/* Correo electrónico (cuentas por cobrar) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.refFin1Correo}
                            onChange={(e) => handleInputChange(e, 'refFin1Correo')}
                            className={classNames({ 'p-invalid': showMessages?.refFin1Correo })}
                            tooltip={!editable ? values?.refFin1Correo : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionContacto')}
                            style={!isFieldEditable('InformacionContacto') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('Email')}</label>
                        </div>
                      </div>

                      {/* Número de teléfono */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.refFin1Telefono}
                            onChange={(e) => handleInputChange(e, 'refFin1Telefono')}
                            className={classNames({ 'p-invalid': showMessages?.refFin1Telefono })}
                            tooltip={!editable ? values?.refFin1Telefono : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionContacto')}
                            style={!isFieldEditable('InformacionContacto') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('numeroTelefono')}</label>
                        </div>
                      </div>
                    </div>
                    <div>{setLabel('Contacto')} 2</div>
                    <div className="inputsProveedorContainer" >
                      {/* Contacto de cuentas por cobrar (Nombre) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.refFin2Nombre}
                            onChange={(e) => handleInputChange(e, 'refFin2Nombre')}
                            className={classNames({ 'p-invalid': showMessages?.refFin2Nombre })}
                            tooltip={!editable ? values?.refFin2Nombre : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionContacto')}
                            style={!isFieldEditable('InformacionContacto') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('Nombre')}</label>
                        </div>
                      </div>

                      {/* Correo electrónico (cuentas por cobrar) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.refFin2Correo}
                            onChange={(e) => handleInputChange(e, 'refFin2Correo')}
                            className={classNames({ 'p-invalid': showMessages?.refFin2Correo })}
                            tooltip={!editable ? values?.refFin2Correo : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionContacto')}
                            style={!isFieldEditable('InformacionContacto') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('Email')}</label>
                        </div>
                      </div>

                      {/* Número de teléfono */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.refFin2Telefono}
                            onChange={(e) => handleInputChange(e, 'refFin2Telefono')}
                            className={classNames({ 'p-invalid': showMessages?.refFin2Telefono })}
                            tooltip={!editable ? values?.refFin2Telefono : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionContacto')}
                            style={!isFieldEditable('InformacionContacto') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('numeroTelefono')}</label>
                        </div>
                      </div>
                    </div>
                    {/* MENSAJES DE ERROR */}
                    {showMessages.ConcactoFinanzas && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}
                  </div>

                )} />

              {/* INFORMACION BANCARIA HONDURAS*/}
              {(values?.PaisCuentaBancaria?.Id) === IdHonduras &&
                <Card
                titulo={setLabel('informacionBancaria')}
                contenido={(
                  <div>
                      <p style={{ padding: '0 15px', fontWeight: 600, color: colorTexto }}>{setLabel('text7PBancos')}</p>
                      <div className='pb-4 pt-4' style={{ width: '20%', padding: '0 15px' }}>
                        <AutoCompleteDropdown
                          name={'PaisCuentaBancaria'}
                          value={values.PaisCuentaBancaria}
                          label={setLabel('BancoPais')}
                          items={Countries}
                          field={'Name'}
                          handleInputChange={handleInputChange}
                          className={classNames({ 'p-invalid': showMessages?.PaisCuentaBancaria })}
                          // enable={editable}
                          enable={isFieldEditable('InformacionBancaria')}
                        />
                      </div>
                      <p style={{ padding: '0 15px', fontWeight: 600, color: colorTexto}}>{setLabel('text0PBancos')}</p>
                      <p style={{ padding: '0 15px', fontWeight: 600, color: colorTexto}}>{setLabel('textPBancos')}</p>
                      <p style={{ padding: '0 25px', fontWeight: 600, color: colorTexto}}>{setLabel('text3PBancos')}</p>
                      <p style={{ padding: '0 25px', fontWeight: 600, color: colorTexto}}>{setLabel('text4PBancos')}</p>
                      <p style={{ padding: '0 15px', fontWeight: 100, color: colorTexto}}>{setLabel('text2PBancos')}</p>
                      <div className="inputsProveedorContainer" >
                        {/* Número de cuenta  */}
                        <div className='input-contenedor'>
                          <div className="p-float-label">
                            <InputText
                              value={values?.NumeroCuentaBancaria}
                              onChange={(e) => handleInputChange(e, 'NumeroCuentaBancaria')}
                              className={classNames({ 'p-invalid': showMessages?.NumeroCuentaBancaria })}
                              tooltip={!editable ? values?.NumeroCuentaBancaria : undefined}
                              tooltipOptions={{ position: 'top' }}
                              // readOnly={!editable}
                              readOnly={!isFieldEditable('InformacionBancaria')}
                              style={!isFieldEditable('InformacionBancaria') ? { cursor: 'default', color: 'gray' } : {}}
                            />
                            <label>{setLabel('numeroCuenta')}</label>
                          </div>
                        </div>

                        {/* A nombre de */}
                        <div className='input-contenedor'>
                          <div className="p-float-label">
                            <InputText
                              value={values?.TitularCuenta}
                              onChange={(e) => handleInputChange(e, 'TitularCuenta')}
                              className={classNames({ 'p-invalid': showMessages?.TitularCuenta })}
                              tooltip={!editable ? values?.TitularCuenta : undefined}
                              tooltipOptions={{ position: 'top' }}
                              // readOnly={!editable}
                              readOnly={!isFieldEditable('InformacionBancaria')}
                              style={!isFieldEditable('InformacionBancaria') ? { cursor: 'default', color: 'gray' } : {}}
                            />
                            <label>{setLabel('titularCuenta')}</label>
                          </div>
                        </div>

                        {/* BANCO */}

                        <div>
                          <AutoCompleteDropdown
                            name={'Banco'}
                            value={values?.Banco}
                            label={setLabel('Banco')}
                            items={Bancos}
                            field={'NombreBanco'}
                            handleInputChange={handleInputChange}
                            className={classNames({ 'p-invalid': showMessages?.Banco })}
                            // enable={editable}
                            enable={isFieldEditable('InformacionBancaria')}
                          />
                        </div>

                        {/* Tipo de cuenta */}
                        <div>
                          <AutoCompleteDropdown
                            name={'TipoCuenta'}
                            value={values?.TipoCuenta}
                            label={setLabel('tipoCuenta')}
                            items={tiposCuentas}
                            field={'tipo'}
                            handleInputChange={handleInputChange}
                            className={classNames({ 'p-invalid': showMessages?.TipoCuenta })}
                            // enable={editable}
                            enable={isFieldEditable('InformacionBancaria')}
                          />
                        </div>

                        {/* Tipo de Moneda */}
                        <div>
                          <AutoCompleteDropdown
                            name={'Currency'}
                            value={values?.Currency}
                            label={setLabel('Moneda')}
                            items={Currencies}
                            field={'Currency'}
                            handleInputChange={handleInputChange}
                            className={classNames({ 'p-invalid': showMessages?.Currency })}
                            // enable={editable}
                            enable={isFieldEditable('InformacionBancaria')}
                          />
                        </div>

                      </div>

                      {
                        values?.Banco && ![2, 19].includes(values.Banco.IdBanco) && (
                          <>
                            <p style={{ padding: '0 15px', fontWeight: 600 }}>{setLabel('textCondicion')}
                              <span style={{}}> {setLabel('text1Condicion')}</span>
                            </p>

                            <p style={{ padding: '0 15px', fontWeight: 600 }}>{setLabel('text2Condicion')}
                              <span style={{}}> {setLabel('text3Condicion')}</span>
                            </p>

                            <p style={{ padding: '0 15px', fontWeight: 600 }}>{setLabel('opciones')}</p>

                            <p style={{ padding: '0 15px', fontWeight: 600 }}>{setLabel('opcion1')}
                              <span style={{ fontWeight: 200 }}> {setLabel('opcion1Text')}</span>
                            </p>

                            <div className='d-flex align-items-center mb-3' style={{ marginLeft: 10, fontWeight: 600 }}>
                              <RadioButton
                                required={true}
                                checked={values?.selectedOption === 'DeduccionACH'}
                                onChange={(e) => handleInputChange2(e, 'DeduccionACH')}
                                className={classNames('mx-3', { 'p-invalid': showMessages?.DeduccionACH })}
                                // disabled={!editable}
                                disabled={!isFieldEditable('InformacionBancaria')}
                                value="DeduccionACH"
                              />
                              <span>{setLabel('Acepto')}</span>
                            </div>

                            <p style={{ padding: '0 15px', fontWeight: 600 }}>{setLabel('opcion2')}
                              <span style={{ fontWeight: 200 }}> {setLabel('opcion2Text')}</span>
                            </p>

                            <div className='d-flex align-items-center mb-3' style={{ marginLeft: 10, fontWeight: 600 }}>
                              <RadioButton
                                required={true}
                                checked={values?.selectedOption === 'PagarCheque'}
                                onChange={(e) => handleInputChange2(e, 'PagarCheque')}
                                className={classNames('mx-3', { 'p-invalid': showMessages?.PagarCheque })}
                                // disabled={!editable}
                                disabled={!isFieldEditable('InformacionBancaria')}
                                value="PagarCheque"
                              />
                              <span>{setLabel('PagarCheque')}</span>
                            </div>
                            <div className=''>
                              {values?.selectedOption === 'PagarCheque' && (
                                <div>
                                  <p style={{ padding: '0 15px', fontWeight: 600 }}>{setLabel('compromiso')}</p>
                                  <p style={{ padding: '0 15px', fontWeight: 200, marginLeft: 5 }}>{setLabel('compromisoText')}</p>
                                  <p style={{ padding: '0 15px', fontWeight: 200, marginLeft: 5 }}>{setLabel('compromisoText2')}</p>
                                </div>
                              )}
                              {showMessages.selectedOption && <div className="p-error">{setLabel('marcarOpcion')}</div>}
                            </div>
                          </>
                        )
                      }

                      <p style={{ padding: '0 15px', fontWeight: 600, fontSize: 11.5, color: colorTexto }}>{setLabel('text5PBancos')}
                        <span style={{ fontStyle: 'italic', fontWeight: 600, color: colorTexto }}> {setLabel('text6PBancos')}</span>
                      </p>
                      {/* MENSAJES DE ERROR */}
                      {showMessages.Banco && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}
                    </div>
                  )}
                />}


              {/* INFORMACION BANCARIA INTERNACIONAL */}
              {(values?.PaisCuentaBancaria?.Id) !== IdHonduras &&
                <Card
                  titulo={setLabel('informacionBancaria')}
                  contenido={(
                    <div>
                      <p style={{ padding: '0 15px', fontWeight: 600, color: colorTexto }}>{setLabel('text7PBancos')}</p>
                      <div className='pb-4 pt-4' style={{ width: '20%', padding: '0 15px' }}>
                        <AutoCompleteDropdown
                          name={'PaisCuentaBancaria'}
                          value={values.PaisCuentaBancaria}
                          label={setLabel('BancoPais')}
                          items={Countries}
                          field={'Name'}
                          handleInputChange={handleInputChange}
                          className={classNames({ 'p-invalid': showMessages?.PaisCuentaBancaria })}
                          // enable={editable}
                          enable={isFieldEditable('InformacionBancaria')}
                        />
                      </div>
                      <p style={{ padding: '0 15px', fontWeight: 600, color: colorTexto }}>{setLabel('textBancosInter')}</p>
                      <p style={{ padding: '0 15px', fontWeight: 600, color: colorTexto }}>{setLabel('text1BancosInter')}
                        <span style={{ fontStyle: 'italic', fontWeight: 600, color: colorTexto }}> {setLabel('text2BancosInter')}</span>
                      </p>
                      <p style={{ padding: '0 15px', fontWeight: 600, marginLeft: 5, color: colorTexto }}>{setLabel('text3BancosInter')}</p>
                      <p style={{ padding: '0 15px', fontWeight: 600, marginLeft: 5, color: colorTexto }}>{setLabel('text4BancosInter')}</p>
                      {/* <p style={{ padding: '0 15px', fontWeight: 600, marginLeft:5 }}>{setLabel('text5BancosInter')}</p> */}

                      <div className="inputsProveedorContainer">
                        {/* Tipo de Moneda */}
                        <div>
                          <AutoCompleteDropdown
                            name={'Currency'}
                            value={values?.Currency}
                            label={setLabel('Moneda')}
                            items={Currencies}
                            field={'Currency'}
                            handleInputChange={handleInputChange}
                            className={classNames({ 'p-invalid': showMessages?.Currency })}
                            // enable={editable}
                            enable={isFieldEditable('InformacionBancaria')}
                          />
                        </div>
                      </div>

                      <div className=''>
                        <span style={{ fontWeight: 800, marginLeft: 10, color: colorTexto }}>{setLabel('bancoIntermediario')}:</span>
                      </div>

                      <div className='inputsProveedorContainer'>

                        {/* BANCO INTERMEDIARIO */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values?.BancoIntermediarioNombre}
                              onChange={(e) => handleInputChange(e, 'BancoIntermediarioNombre')}
                              tooltip={!editable ? values?.BancoIntermediarioNombre : undefined}
                              tooltipOptions={{ position: 'top' }}
                              // readOnly={!editable}
                              readOnly={!isFieldEditable('InformacionBancaria')}
                              style={!isFieldEditable('InformacionBancaria') ? { cursor: 'default', color: 'gray' } : {}}
                            />
                            <label>{setLabel('Banco')}</label>
                          </div>
                        </div>
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values?.BancoIntermediarioDireccion}
                              onChange={(e) => handleInputChange(e, 'BancoIntermediarioDireccion')}
                              tooltip={!editable ? values?.BancoIntermediarioDireccion : undefined}
                              tooltipOptions={{ position: 'top' }}
                              // readOnly={!editable}
                              readOnly={!isFieldEditable('InformacionBancaria')}
                              style={!isFieldEditable('InformacionBancaria') ? { cursor: 'default', color: 'gray' } : {}}
                            />
                            <label>{setLabel('Direccion')}</label>
                          </div>
                        </div>
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values?.BancoIntermediarioSwift}
                              onChange={(e) => handleInputChange(e, 'BancoIntermediarioSwift')}
                              tooltip={!editable ? values?.BancoIntermediarioSwift : undefined}
                              tooltipOptions={{ position: 'top' }}
                              // readOnly={!editable}
                              readOnly={!isFieldEditable('InformacionBancaria')}
                              style={!isFieldEditable('InformacionBancaria') ? { cursor: 'default', color: 'gray' } : {}}
                            />
                            <label>{setLabel('Swift')}</label>
                          </div>
                        </div>
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values?.BancoIntermediarioAbaBin}
                              onChange={(e) => handleInputChange(e, 'BancoIntermediarioAbaBin')}
                              tooltip={!editable ? values?.BancoIntermediarioAbaBin : undefined}
                              tooltipOptions={{ position: 'top' }}
                              // readOnly={!editable}
                              readOnly={!isFieldEditable('InformacionBancaria')}
                              style={!isFieldEditable('InformacionBancaria') ? { cursor: 'default', color: 'gray' } : {}}
                            />
                            <label>{setLabel('ABA / BIN')}</label>
                          </div>
                        </div>
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values?.BancoIntermediarioCuenta}
                              onChange={(e) => handleInputChange(e, 'BancoIntermediarioCuenta')}
                              tooltip={!editable ? values?.BancoIntermediarioCuenta : undefined}
                              tooltipOptions={{ position: 'top' }}
                              // readOnly={!editable}
                              readOnly={!isFieldEditable('InformacionBancaria')}
                              style={!isFieldEditable('InformacionBancaria') ? { cursor: 'default', color: 'gray' } : {}}
                            />
                            <label>{setLabel('numeroCuenta')}</label>
                          </div>
                        </div>

                      </div>


                      <div className=''>
                        <span style={{ fontWeight: 800, marginLeft: 10, color: colorTexto }}>{setLabel('bancoBeneficiario')}:</span>
                      </div>
                      <div className='inputsProveedorContainer'>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.BancoBeneficiarioNombre}
                              onChange={(e) => handleInputChange(e, 'BancoBeneficiarioNombre')}
                              className={classNames({ 'p-invalid': showMessages?.BancoBeneficiarioNombre })}
                              // disabled={!editable}
                              disabled={!isFieldEditable('InformacionBancaria')}
                            />
                            <label>{setLabel('Banco')}</label>
                          </div>
                        </div>
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.BancoBeneficiarioDireccion}
                              onChange={(e) => handleInputChange(e, 'BancoBeneficiarioDireccion')}
                              className={classNames({ 'p-invalid': showMessages?.BancoBeneficiarioDireccion })}
                              // disabled={!editable}
                              disabled={!isFieldEditable('InformacionBancaria')}
                            />
                            <label>{setLabel('Direccion')}</label>
                          </div>
                        </div>
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.BancoBeneficiarioSwift}
                              onChange={(e) => handleInputChange(e, 'BancoBeneficiarioSwift')}
                              className={classNames({ 'p-invalid': showMessages?.BancoBeneficiarioSwift })}
                              // disabled={!editable}
                              disabled={!isFieldEditable('InformacionBancaria')}
                            />
                            <label>{setLabel('Swift')}</label>
                          </div>
                        </div>
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.BancoBeneficiarioNombreBeneficiario}
                              onChange={(e) => handleInputChange(e, 'BancoBeneficiarioNombreBeneficiario')}
                              className={classNames({ 'p-invalid': showMessages?.BancoBeneficiarioNombreBeneficiario })}
                              // disabled={!editable}
                              disabled={!isFieldEditable('InformacionBancaria')}
                            />
                            <label style={{ color: colorTexto }}>{setLabel('nombreBeneficiario')}</label>
                          </div>
                        </div>
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.BancoBeneficiarioAbaBin}
                              onChange={(e) => handleInputChange(e, 'BancoBeneficiarioAbaBin')}
                              className={classNames({ 'p-invalid': showMessages?.BancoBeneficiarioAbaBin })}
                              // disabled={!editable}
                              disabled={!isFieldEditable('InformacionBancaria')}
                            />
                            <label>{setLabel('ABA / BIN')}</label>
                          </div>
                        </div>
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.BancoBeneficiarioCuenta}
                              onChange={(e) => handleInputChange(e, 'BancoBeneficiarioCuenta')}
                              className={classNames({ 'p-invalid': showMessages?.BancoBeneficiarioCuenta })}
                              // disabled={!editable}
                              disabled={!isFieldEditable('InformacionBancaria')}
                            />
                            <label>{setLabel('numeroCuenta')}</label>
                          </div>
                        </div>



                      </div>

                      <p style={{ padding: '0 15px', fontWeight: 600, fontSize: 11.5, marginTop: 15, color: colorTexto }}>{setLabel('text5PBancos')}
                        <span style={{ fontStyle: 'italic', fontWeight: 600, color: colorTexto }}> {setLabel('text6BancosInter')}</span>
                      </p>
                      {/* MENSAJES DE ERROR */}
                      {showMessages.Banco && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}
                    </div>
                  )} />}

              {/* REFERENCIAS COMERCIALES */}
              <Card
                titulo={setLabel('referenciasComerciales')}
                contenido={(
                  <div className="">

                    {/* NOMBRE COMPAñIA 1 */}
                    <div className='seccionText'>
                      <span style={{ color: colorTexto }}>{setLabel('Referencia')} 1:</span>
                    </div>

                    <div className='inputsProveedorContainer'>
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.ref1Nombre}
                            onChange={(e) => handleInputChange(e, 'ref1Nombre')}
                            className={classNames({ 'p-invalid': showMessages?.ref1Nombre })}
                            tooltip={!editable ? values?.ref1Nombre : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionComercial')}
                            style={!isFieldEditable('InformacionComercial') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('Nombre')}</label>
                        </div>
                      </div>
                      {/* Telefono */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.ref1Telefono}
                            onChange={(e) => handleInputChange(e, 'ref1Telefono')}
                            className={classNames({ 'p-invalid': showMessages?.ref1Telefono })}
                            tooltip={!editable ? values?.ref1Telefono : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionComercial')}
                            style={!isFieldEditable('InformacionComercial') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('numeroTelefono')}</label>
                        </div>
                      </div>
                      {/* Correo */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.ref1Correo}
                            onChange={(e) => handleInputChange(e, 'ref1Correo')}
                            className={classNames({ 'p-invalid': showMessages?.ref1Correo })}
                            tooltip={!editable ? values?.ref1Correo : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionComercial')}
                            style={!isFieldEditable('InformacionComercial') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('Email')}</label>
                        </div>
                      </div>
                    </div>

                    {/* NOMBRE COMPAñIA 2 */}
                    <div className='seccionText'>
                      <span style={{ color: colorTexto }}>{setLabel('Referencia')} 2:</span>
                    </div>

                    <div className='inputsProveedorContainer'>
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.ref2Nombre}
                            onChange={(e) => handleInputChange(e, 'ref2Nombre')}
                            className={classNames({ 'p-invalid': showMessages?.ref2Nombre })}
                            tooltip={!editable ? values?.ref2Nombre : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionComercial')}
                            style={!isFieldEditable('InformacionComercial') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('Nombre')}</label>
                        </div>
                      </div>
                      {/* Telefono */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.ref2Telefono}
                            onChange={(e) => handleInputChange(e, 'ref2Telefono')}
                            className={classNames({ 'p-invalid': showMessages?.ref2Telefono })}
                            tooltip={!editable ? values?.ref2Telefono : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionComercial')}
                            style={!isFieldEditable('InformacionComercial') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('numeroTelefono')}</label>
                        </div>
                      </div>
                      {/* Correo */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.ref2Correo}
                            onChange={(e) => handleInputChange(e, 'ref2Correo')}
                            className={classNames({ 'p-invalid': showMessages?.ref2Correo })}
                            tooltip={!editable ? values?.ref2Correo : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // readOnly={!editable}
                            readOnly={!isFieldEditable('InformacionComercial')}
                            style={!isFieldEditable('InformacionComercial') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('Email')}</label>
                        </div>
                      </div>
                    </div>

                    {/* MENSAJES DE ERROR */}
                    {showMessages.ReferenciasComerciales && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}
                  </div>

                )}
              />


              {/* ACTIVOS DE LA EMPRESA */}
              <Card
                titulo={setLabel('informacionFinanciera')}
                contenido={
                  <div>
                    <div style={{ width: 200 }}>
                      <AutoCompleteDropdown
                        name={'CurrencyFin'}
                        value={values?.CurrencyFin}
                        label={setLabel('Moneda')}
                        items={Currencies}
                        field={'Currency'}
                        handleInputChange={handleInputChange}
                        className={classNames({ 'p-invalid': showMessages?.CurrencyFin })}
                        // enable={editable}
                        enable={isFieldEditable('InformacionFinanciera')}
                      />
                    </div>
                    <div className='seccionText'>
                      <span style={{ color: colorTexto }}>{setLabel('Activos')}:</span>
                    </div>
                    <div className='inputsProveedorContainer'>
                      {/* ACTIVOS CORRIENTES */}
                      <div>
                        <div className="p-float-label">
                          <InputNumber
                            value={values?.ActivosCorrientes}
                            onChange={(e) => handleInputChange(e, 'ActivosCorrientes')}
                            className={classNames({ 'p-invalid': showMessages?.ActivosCorrientes })}
                            maxFractionDigits={2}
                            tooltip={!editable ? values?.ActivosCorrientes : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // disabled={!editable}
                            disabled={!isFieldEditable('InformacionFinanciera')}
                            style={!isFieldEditable('InformacionFinanciera') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('ActivosCorrientes')}</label>
                        </div>
                      </div>
                      {/* TOTAL ACTIVOS */}
                      <div>
                        <div className="p-float-label">
                          <InputNumber
                            value={values?.TotalActivos}
                            onChange={(e) => handleInputChange(e, 'TotalActivos')}
                            className={classNames({ 'p-invalid': showMessages?.TotalActivos })}
                            maxFractionDigits={2}
                            tooltip={!editable ? values?.TotalActivos : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // disabled={!editable}
                            disabled={!isFieldEditable('InformacionFinanciera')}
                            style={!isFieldEditable('InformacionFinanciera') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('TotalActivos')}</label>
                        </div>
                      </div>

                    </div>

                    <div className='seccionText'>
                      <span style={{ color: colorTexto }}>{setLabel('Pasivos')}:</span>
                    </div>
                    <div className='inputsProveedorContainer'>
                      {/* PASIVOS CORRIENTES */}
                      <div>
                        <div className="p-float-label">
                          <InputNumber
                            value={values?.PasivosCorrientes}
                            onChange={(e) => handleInputChange(e, 'PasivosCorrientes')}
                            className={classNames({ 'p-invalid': showMessages?.PasivosCorrientes })}
                            maxFractionDigits={2}
                            tooltip={!editable ? values?.PasivosCorrientes : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // disabled={!editable}
                            disabled={!isFieldEditable('InformacionFinanciera')}
                            style={!isFieldEditable('InformacionFinanciera') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('PasivosCorrientes')}</label>
                        </div>
                      </div>

                      {/* TOTAL PASIVOS */}
                      <div>
                        <div className="p-float-label">
                          <InputNumber
                            value={values?.TotalPasivos}
                            onChange={(e) => handleInputChange(e, 'TotalPasivos')}
                            className={classNames({ 'p-invalid': showMessages?.TotalPasivos })}
                            maxFractionDigits={2}
                            tooltip={!editable ? values?.TotalPasivos : undefined}
                            tooltipOptions={{ position: 'top' }}
                            // disabled={!editable}
                            disabled={!isFieldEditable('InformacionFinanciera')}
                            style={!isFieldEditable('InformacionFinanciera') ? { cursor: 'default', color: 'gray' } : {}}
                          />
                          <label>{setLabel('TotalPasivos')}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              />

              {/* C */}
              <Card
                titulo={setLabel('Documentation')}
                contenido={(
                  <div  >

                    <div className='seccionText'>
                      <span style={{ color: colorTexto }}>{setLabel('adjuntarDocumentos')}</span>

                    </div>
                    <div className="">
                      {/* RTN */}

                      {/* {(ArchivoBIC?.name ? ArchivoBIC.name : '')} */}
                      <div className="mb-3">
                        <label for="formFile" className="form-label" style={{ color: colorTexto }}><strong>BIC:</strong> RTN/NIT/RUC/TAX ID</label>
                        {values.BICName && <p style={{ color: colorTexto }}>{setLabel('ArchivoActual')}: <span className='link' onClick={() => descargarArchivo('getBICFile', values.BICName)}>{values.BICName}</span></p>}
                        <input
                          className={classNames('form-control p-inputtext p-component', { 'p-invalid': showMessages?.resultArchivoBIC })}
                          type="file" name='FileRTN'
                          onChange={(e) => setArchivoBIC(e.target.files[0])}
                          // disabled={!editable}
                          disabled={!isFieldEditable('Documentacion')}
                          lang={lang}
                        />
                      </div>

                      {/* {values?.Country?.Id !== IdHonduras &&(
                        <div className="mb-3">
                          <p style={{ padding: '0 15px', fontWeight: 600 }}>{setLabel('notasClave')}</p>
                          <p style={{ padding: '0 15px', fontWeight: 600 }}>{setLabel('notasText1')}
                            <span style={{fontWeight: 100}}> {setLabel('notasText2')}</span>
                          </p>
                          <p style={{ padding: '0 15px', fontWeight: 600 }}>{setLabel('notasText3')}
                            <span style={{fontWeight: 100}}> {setLabel('notasText4')}</span>
                          </p>

                          <label for="formFile" className="form-label"><strong>{setLabel('pasaporte')}:</strong></label>
                          {values.CertificadoName && <p>{setLabel('ArchivoActual')}: <span className='link' onClick={() => descargarArchivo('getCertificadoFile', values.CertificadoName)}>{values.CertificadoName}</span></p>}

                          <input
                            className={classNames('form-control p-inputtext p-component', { 'p-invalid': showMessages?.resultArchivoCertificado })}
                            type="file"
                            name='FileCertificado'
                            onChange={e => setArchivoCertificado(e.target.files[0])}
                            disabled={!editable}
                          />
                        </div>
                      )} */}

                      {/* FACTURA */}
                      <div className="mb-3">
                        <label for="formFile" className="form-label" style={{ color: colorTexto }}><strong>{setLabel('Factura')}:</strong></label>
                        {values.FacturaName && <p style={{ color: colorTexto }}>{setLabel('ArchivoActual')}: <span className='link' onClick={() => descargarArchivo('getFacturaFile', values.FacturaName)}>{values.FacturaName}</span></p>}
                        <input
                          className={classNames('form-control p-inputtext p-component', { 'p-invalid': showMessages?.resultArchivoFactura })}
                          type="file"
                          name='Factura'
                          onChange={e => setArchivoFactura(e.target.files[0])}
                          // disabled={!editable}
                          disabled={!isFieldEditable('Documentacion')}
                        />
                      </div>

                      {/* PERMISO DE OPERACIONES */}
                      {values?.Country?.Id === IdHonduras && <div>
                        <div>
                          <div className="mb-3">
                            <label for="formFile" className="form-label" style={{ color: colorTexto }}><strong>{setLabel('PermisoOperaciones')}:</strong></label>
                            {values.PermisoOperacionesName && <p style={{ color: colorTexto }}>{setLabel('ArchivoActual')}: <span className='link' onClick={() => descargarArchivo('getPermisoOperacionesFile', values.PermisoOperacionesName)}>{values.PermisoOperacionesName}</span></p>}

                            <input
                              className={classNames('form-control p-inputtext p-component', { 'p-invalid': showMessages?.resultArchivoPermisoOperaciones })}
                              type="file"
                              name='FilePermisoOperaciones'
                              onChange={(e) => setArchivoPermisoOperaciones(e.target.files[0])}
                              // disabled={!editable}
                              disabled={!isFieldEditable('Documentacion')}
                              lang={lang}
                            />
                          </div>
                        </div>
                      </div>}

                      {/* Escritura Constitucion */}
                      <div>
                        <div>
                          <div className="mb-3">
                            <label for="formFile" className="form-label" style={{ color: colorTexto }}><strong>{setLabel('escrituraConstitucion')}:</strong></label>
                            {values.EscrituraConstitucionName && <p style={{ color: colorTexto }}>{setLabel('ArchivoActual')}: <span className='link' onClick={() => descargarArchivo('getEscrituraConstitucionFile', values.EscrituraConstitucionName)}>{values.EscrituraConstitucionName}</span></p>}
                            <input
                              className={classNames('form-control p-inputtext p-component', { 'p-invalid': showMessages?.setResultArchivoEscrituraConstitucion })}
                              type="file"
                              name='EscrituraConstitucion'
                              onChange={(e) => setArchivoEscrituraConstitucion(e.target.files[0])}
                              // disabled={!editable}
                              disabled={!isFieldEditable('Documentacion')}
                              lang={lang}
                            />
                          </div>
                        </div>
                      </div>


                      {values?.Country?.Id === IdHonduras && <div>

                        {/* ARCHIVO NACIONAL */}
                        <div style={{ border: "2px solid", paddingLeft: 3, paddingRight: 3, borderRadius: "6px" }} ref={sectionRef}  >
                          <p style={{ fontWeight: 800, fontSize: 11.5, marginTop: 20, color: colorTexto }}>{setLabel('declaracion')}
                            <span style={{ fontStyle: 'italic', fontWeight: 800 }}> {setLabel('declaracionP')}</span>
                          </p>
                          <p style={{ padding: '0 15px', fontWeight: 600, color: colorTexto }}>{setLabel('regExoneradoT')}</p>
                          <p style={{ padding: '0 15px', fontWeight: 600, color: colorTexto }}>{setLabel('constPagosT')}</p>

                          <p style={{ fontWeight: 600, color: colorTexto }}>{setLabel('declaracionP2')}</p>

                          <div className='d-flex mt-4 border-top py-3 border-bottom align-items-center' >
                            <label className='mx-3' htmlFor="FileNacional" style={{ color: colorTexto }}><strong>{setLabel('zonaLibre')}:</strong></label>
                            <label className={classNames('mx-3', { 'fw-bold': ArchivoSelected === 0 })} htmlFor="FileNacional" style={{ color: colorTexto }}>{setLabel('no')}</label>
                            <InputSwitch checked={ArchivoSelected === 1} onChange={() => { ArchivoSelected === 1 ? setArchivoSelected(0) : setArchivoSelected(1) }} />
                            <label className={classNames('mx-3', { 'fw-bold': ArchivoSelected === 1 })} htmlFor="FileNacional" style={{ color: colorTexto }}>{setLabel('si')}</label>

                            {(ArchivoSelected === 1 ? true : (ArchivoSelected === 0 && values?.TieneConstPagosCuenta ? true : false))
                              && (
                                <div className='d-flex gap' >
                                  <Button icon="pi pi-plus" className='p-button-secondary' style={{ height: 40 }}
                                    aria-label="Search" onClick={ArchivoSelected === 1 ? limpiarZonaLibre : limpiarConstanciaPagos} />
                                  {botonRegistro && (
                                    <Button
                                      icon="pi pi-plus"
                                      label={setLabel('AgregarRegistro')}
                                      className='p-button-secondary mb-2'
                                      style={{ height: 40 }}
                                      aria-label="Search"
                                      onClick={addRegistro} />
                                  )}
                                </div>
                              )}
                          </div>

                          {ArchivoSelected === 1 && (
                            <div>
                              <div className='mt-2'>
                                <Checkbox
                                  required={true}
                                  checked={values?.SinRegistroExonerado}
                                  onChange={(e) => {
                                    const isChecked = e.checked;

                                    setValues(prev => ({
                                      ...prev,
                                      SinRegistroExonerado: isChecked,
                                      ...(isChecked && {
                                        RegistroExonerado: '',
                                        FechaVencimiento: null,
                                        NombreZonaLibre: '',
                                        DireccionZonaLibre: '',
                                      })
                                    }));
                                  }}
                                  className={classNames('mx-2 my-2', { 'p-invalid': showMessages?.SinRegistroExonerado })}
                                // disabled={!editable2}
                                />
                                <label for="formFile" className="form-label" style={{ color: colorTexto }}>
                                  <strong>{setLabel('regExonerado')}</strong>
                                </label>
                              </div>
                              {values?.SinRegistroExonerado && (
                                <p style={{ textAlign: 'center', fontSize: '1rem', fontWeight: 600, color: colorTexto }}>{setLabel('msjZonaLibre')}</p>
                              )}
                            </div>
                          )}

                          {ArchivoSelected === 1 && !values.SinRegistroExonerado && (
                            <div className='inputsProveedorContainer'>
                              <div className='input-contenedor'>
                                <div className="p-float-label">
                                  <InputText
                                    value={values?.RegistroExonerado}
                                    onChange={(e) => handleInputChange(e, 'RegistroExonerado')}
                                    className={classNames({ 'p-invalid': showMessages?.RegistroExonerado })}
                                    tooltip={!editable || zonaLibreDeshabilitada ? values?.RegistroExonerado : undefined}
                                    tooltipOptions={{ position: 'top' }}
                                    // readOnly={!editable2 || zonaLibreDeshabilitada}
                                    // readOnly={!isFieldEditable('Documentacion') || zonaLibreDeshabilitada}
                                    // style={!isFieldEditable('Documentacion') || zonaLibreDeshabilitada ? { cursor: 'default', color: 'gray' } : {}}
                                    readOnly={zonaLibreDeshabilitada}
                                    style={zonaLibreDeshabilitada ? { cursor: 'default', color: 'gray' } : {}}
                                  />
                                  <label style={{ color: colorTexto }}>{setLabel('RegistroExonerado')}</label>
                                </div>
                              </div>
                              <div className='input-contenedor'>
                                <div className="p-float-label">
                                  <Calendar
                                    value={values.FechaInicio}
                                    onChange={(e) => setValues(prev => ({ ...prev, FechaInicio: e.value }))}
                                    dateFormat="yy-mm-dd"
                                    className={classNames({ 'p-invalid': showMessages?.FechaInicio })}
                                    style={{ height: 40 }}
                                    // disabled={!editable2 || zonaLibreDeshabilitada}
                                    // disabled={!isFieldEditable('Documentacion') || zonaLibreDeshabilitada}
                                    disabled={zonaLibreDeshabilitada}
                                    showIcon
                                  />
                                  <label style={{ color: colorTexto }}>{setLabel('FechaInicio')}</label>
                                </div>
                              </div>


                              <div className='input-contenedor'>
                                <div className="p-float-label">
                                  <Calendar
                                    value={values.FechaVencimiento}
                                    onChange={(e) => setValues(prev => ({ ...prev, FechaVencimiento: e.value }))}
                                    dateFormat="yy-mm-dd"
                                    className={classNames({ 'p-invalid': showMessages?.FechaVencimiento })}
                                    style={{ height: 40 }}
                                    // disabled={!editable2 || zonaLibreDeshabilitada}
                                    // disabled={!isFieldEditable('Documentacion') || zonaLibreDeshabilitada}
                                    disabled={zonaLibreDeshabilitada}
                                    showIcon
                                  />
                                  <label>{setLabel('FechaVencimiento')}</label>
                                  {/* <label>Expired Date</label> */}
                                </div>
                              </div>

                              {/* NOMBRE ZONA */}
                              <div className='input-contenedor'>
                                <div className="p-float-label">
                                  <InputText
                                    value={values?.NombreZonaLibre}
                                    onChange={(e) => handleInputChange(e, 'NombreZonaLibre')}
                                    className={classNames({ 'p-invalid': showMessages?.NombreZonaLibre })}
                                    tooltip={!editable || zonaLibreDeshabilitada ? values?.NombreZonaLibre : undefined}
                                    tooltipOptions={{ position: 'top' }}
                                    // readOnly={!editable2 || zonaLibreDeshabilitada}
                                    // readOnly={!isFieldEditable('Documentacion') || zonaLibreDeshabilitada}
                                    // style={!isFieldEditable('Documentacion') || zonaLibreDeshabilitada ? { cursor: 'default', color: 'gray' } : {}}
                                    readOnly={zonaLibreDeshabilitada}
                                    style={zonaLibreDeshabilitada ? { cursor: 'default', color: 'gray' } : {}}
                                  />
                                  <label>{setLabel('nombreZona')}</label>
                                </div>
                              </div>

                              {/* DIRECCION ZONA */}
                              <div className='input-contenedor'>
                                <div className="p-float-label">
                                  <InputText
                                    value={values?.DireccionZonaLibre}
                                    onChange={(e) => handleInputChange(e, 'DireccionZonaLibre')}
                                    className={classNames({ 'p-invalid': showMessages?.DireccionZonaLibre })}
                                    tooltip={!editable || zonaLibreDeshabilitada ? values?.DireccionZonaLibre : undefined}
                                    tooltipOptions={{ position: 'top' }}
                                    // readOnly={!editable2 || zonaLibreDeshabilitada}
                                    // readOnly={!isFieldEditable('Documentacion') || zonaLibreDeshabilitada}
                                    // style={!isFieldEditable('Documentacion') || zonaLibreDeshabilitada? { cursor: 'default', color: 'gray' } : {}}
                                    readOnly={zonaLibreDeshabilitada}
                                    style={zonaLibreDeshabilitada ? { cursor: 'default', color: 'gray' } : {}}
                                  />
                                  <label>{setLabel('direccionZona')}</label>
                                </div>
                              </div>
                            </div>
                          )}
                          <div>
                            {ArchivoSelected === 0 ?
                              <div className="mb-3 ">
                                <div className='my-2'>
                                  <div className='my-3 px-3  border-bottom'>
                                    <Checkbox
                                      required={true}
                                      checked={values?.TieneConstPagosCuenta}
                                      onChange={(e) => handleInputChange(e, 'TieneConstPagosCuenta')}
                                      className={classNames('mx-2 my-2', { 'p-invalid': showMessages?.TieneConstPagosCuenta })}
                                      // disabled={!editable}
                                      disabled={!ArchivoSelected === 0}
                                    />
                                    <label for="formFile" className="form-label" style={{ color: colorTexto }}><strong>{setLabel('tieneConstanciaPagos')}</strong></label>
                                  </div>

                                  {!values?.TieneConstPagosCuenta && (
                                    <p style={{ textAlign: 'center', fontSize: '1rem', fontWeight: 600, color: colorTexto }}>{setLabel('msjZonaLibre')}</p>
                                  )}

                                  {values?.TieneConstPagosCuenta && (

                                    <div className='my-2'>
                                      <div className='d-flex gap'>

                                        <div className="p-float-label">
                                          <Calendar
                                            value={values.FechaInicio}
                                            onChange={(e) => setValues(prev => ({ ...prev, FechaInicio: e.value }))}
                                            dateFormat="yy-mm-dd"
                                            className={classNames({ 'p-invalid': showMessages?.FechaInicio })}
                                            style={{ height: 40 }}
                                            // disabled={!editable2}
                                            // disabled={!isFieldEditable('Documentacion')}
                                            disabled={false}
                                            showIcon
                                          />
                                          <label>{setLabel('FechaInicio')}</label>
                                        </div>
                                        <div className="p-float-label">
                                          <Calendar
                                            value={values.FechaVencimiento}
                                            onChange={(e) => setValues(prev => ({ ...prev, FechaVencimiento: e.value }))}
                                            dateFormat="yy-mm-dd"
                                            className={classNames({ 'p-invalid': showMessages?.FechaVencimiento })}
                                            style={{ height: 40 }}
                                            // disabled={!editable2}
                                            // disabled={!isFieldEditable('Documentacion')}
                                            disabled={false}
                                            showIcon
                                          />
                                          <label>{setLabel('FechaVencimiento')}</label>
                                        </div>

                                      </div>
                                      <label for="formFile" className="form-label" style={{ color: colorTexto }}><strong>{setLabel('constPagosCuenta')}:</strong></label>
                                      {values.ConstPagosName && <p>{setLabel('ArchivoActual')}: <span className='link' onClick={() => descargarArchivo('getConstanciaPagosFile', values.ConstPagosName)}>{values.ConstPagosName}</span></p>}

                                      <input
                                        className={classNames('form-control p-inputtext p-component', { 'p-invalid': showMessages?.resultArchivoConstPagosCuenta })}
                                        type="file"
                                        name='FileNacional'
                                        onChange={e => setArchivoConstPagosCuenta(e.target.files[0])}
                                        // disabled={!editable2}
                                        // disabled={!isFieldEditable('Documentacion')}
                                        disabled={false}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div> :
                              <div className="mb-3">
                                {!values?.SinRegistroExonerado && (
                                  <div>


                                    <label for="formFile" className="form-label" style={{ color: colorTexto }}><strong>{setLabel('registroExonerado')}:</strong></label>
                                    <div className='d-flex gap-5'>
                                      {values.RegistroExoneradoName && <p style={{ color: colorTexto }}>{setLabel('ArchivoActual')}: <span className='link' onClick={() => descargarArchivo('getRegistroExoneradoFile', values.RegistroExoneradoName)}>{values.RegistroExoneradoName}</span></p>}
                                    </div>
                                    <input
                                      className={classNames('form-control p-inputtext p-component', { 'p-invalid': showMessages?.resultArchivoRegistroExonerado })}
                                      type="file"
                                      name='FileNacional'
                                      onChange={e => setArchivoRegistroExonerado(e.target.files[0])}
                                      // disabled={!editable2 || zonaLibreDeshabilitada}
                                      // disabled={!isFieldEditable('Documentacion') || zonaLibreDeshabilitada}
                                      disabled={zonaLibreDeshabilitada}
                                    />
                                  </div>
                                )}
                              </div>}
                          </div>
                        </div>
                      </div>}
                    </div>
                    {/* MENSAJES DE ERROR */}
                    {showMessages.Documentos && !showMessages.size && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}
                    {showMessages.Documentos && <div className="p-error">{setLabel('ErrorArchivoTamaño')}</div>}
                  </div>
                )} />
            </div>

            {/* AUTORIZACION */}
            <div className='m-4'>
              <div>
                <div className='d-flex align-items-center mb-3'>
                  <Checkbox
                    required={true}
                    checked={values.AutorizacionDeposito}
                    onChange={(e) => handleInputChange(e, 'AutorizacionDeposito')}
                    className={classNames('mx-3', { 'p-invalid': showMessages?.AutorizacionDeposito })}
                    // disabled={!editable}
                    disabled={!isFieldEditable('Documentacion')}
                  />
                  <span style={{ color: colorTexto }}>
                    {setLabel('autorizacionPagos')}
                  </span>
                </div>
                {/* MENSAJES DE ERROR */}
                {showMessages.AutorizacionDeposito && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}

              </div>
              <br />

              <div style={{ marginLeft: 50 }}>
                <span style={{ color: colorTexto }}>{setLabel('infCierta')}</span>
              </div>
              <div style={{ marginLeft: 5, marginTop: 20 }}>
                <span style={{ fontWeight: 'bold', color: colorTexto }}>{setLabel('Nota')} </span>
                <span style={{ color: colorTexto }}>{setLabel('NotaSubirArchivo')}</span>
              </div>

            </div>

            <div className='d-flex flex-column justify-content-around footerContainer '>
              <div className="d-flex flex-column">
                <div className='botonesContainer'>
                  {/* BOTON DE GUARDAR */}
                  <Button
                    className=' m-2 p-button-success'
                    label={setLabel('guardar')}
                    icon='pi pi-save'
                    onClick={() => { verificarCampos() }}
                    disabled={!isFormEditable()}
                  />
                  {/* <Button
                    className=' m-2 p-button-secondary '
                    label={setLabel('limpiar')}
                    icon='pi pi-trash'
                    onClick={() => { }}
                    disabled={!editable}
                  /> */}
                  {/* IMPRIMIR */}
                  <Button
                    className=' m-2 p-button-info'
                    label={setLabel('Imprimir')}
                    icon='pi pi-print'
                    // onClick={event => window.open(`${process.env.REACT_APP_ENV}/FormatoInscripcionProveedor/${formatCodigoProveedor(idCustomer)}/${idioma}/${Token}`, "MsgWindow", 'height=1200,width=1000')}
                    onClick={() => setShowDialogFormato(true)}
                  />

                  {/* {userAuth?.idUser > 0 && values?.IdStatusRevision === 3723 && ( */}
                  {userAuth?.idUser > 0 && (
                    <Button
                      className='m-2 p-button-success'
                      label={setLabel('Revisar')}
                      icon='pi pi-check'
                      onClick={() => setShowDialogEstadoRevision(true)}
                    />
                  )}

                </div>
                {values.BICName && <div className='mx-2' >
                  <strong style={{ color: colorTexto }}>{setLabel('agregarFormatoInscripcion')}</strong>
                  <div style={{ width: '400px' }}>
                    {values.FormatoInscripcionName && <p><span className='link' onClick={descargarFormatoinscripcion}>{setLabel('descargarArchivoAcutal')}</span></p>}
                    <input
                      className={classNames('form-control p-inputtext p-component', { 'p-invalid': showMessages?.resultArchivoBIC })}
                      type="file" name='FileRTN'
                      onChange={(e) => uploadFormatoInscripcion(e.target.files[0])}
                      lang={lang}
                    />
                  </div>
                </div>}

              </div>
              <div className='d-flex gap boton-flotante2 pt-2' style={{ backgroundColor: "transparent" }}>
                {values?.Country?.Id === IdHonduras ?
                  <Button label={setLabel('actualizarCampos')} className="p-button-rounded p-button-primary" onClick={() => handleScroll()} />
                  : null
                }

                <Button
                  icon="pi pi-question-circle"
                  label={setLabel('ayuda')}
                  // severity="info"
                  className="p-button-rounded p-button-primary "
                  onClick={() => setShowDialogAyuda(true)}
                />

              </div>
            </div>


          </div>

        </div>

        {/* CORREO FORMULARIO LLENO */}
        <div style={{ display: 'none' }}>
          <div id={'CorreoFormCompleto'}>
            <h5>FORMATO DE INSCRIPCIÓN DE PROVEEDORES COMPLETADO</h5>
            <p>Codigo proveedor: {formatCodigoProveedor(idCustomer)}</p>
            <p>Proveedor: {values.CustomerName}</p>
          </div>
          <div id={'FormatoInscripcionProveedor'}>
            {/* <FormatoInscripcionProveedor data={formValues} idioma={idioma} /> */}
          </div>
        </div>

        <DialogEstadoRevision
          visible={showDialogEstadoRevision}
          setVisible={setShowDialogEstadoRevision}
          informacion={values}
          userAuth={userAuth}
          Token={Token}
        />

        {showDialogFormato && (
          <FormatoInscripcionPDF
            setShowDialogFormato={setShowDialogFormato}
            showDialogFormato={showDialogFormato}
            selectedFormato={selectedFormato}
            setSelectedFormato={() => { }}
            Language={idioma}
            Token={Token}
          />
        )}

        {showDialogIncompleto && (
          <Dialog
            visible={showDialogIncompleto}
            onHide={() => setShowDialogIncompleto(false)}
            header={setLabel('msgConfirmacionIncompleta')}
            footer={footerDialog}
          >
            {mensajeFaltantes}
          </Dialog>
        )}

        {showDialogAyuda && (
          <Dialog
            visible={showDialogAyuda}
            onHide={() => setShowDialogAyuda(false)}
            header={setLabel('ayuda')}
            style={{ width: '40%' }}
            modal
          >
            <div style={{ lineHeight: '1.8', fontSize: '1rem' }}>
              <p>{setLabel('ayudaText')}</p>

              <p>
                <i className="pi pi-phone" style={{ marginRight: '8px' }}></i>
                <strong>{setLabel('telefono')}</strong> +504 2625-4400 ext. 189 / 126
              </p>

              <p>
                <i className="pi pi-envelope" style={{ marginRight: '8px' }}></i>
                <strong>{setLabel('email')}</strong>{' '}
                <a href="mailto:administracion@ppf.com.hn">administracion@ppf.com.hn</a>
              </p>
            </div>
          </Dialog>
        )}

      </div >
    );
  } else {
    return (
      <div className="container d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="card text-center p-4 shadow-lg" style={{ maxWidth: '500px' }}>
          <div className="mb-3">
            <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem', color: '#ffc107' }}></i>
          </div>
          <h1 className="h4 text-danger">{setLabel('noPermiso')}</h1>

          <div className="d-flex justify-content-center mt-2 w-100">
            <Button
              icon="pi pi-question-circle"
              label={setLabel('ayuda')}
              severity="info"
              className="p-button-rounded p-button-primary"
              onClick={() => setShowDialogAyuda(true)}
            />
          </div>
        </div>

        {showDialogAyuda && (
          <Dialog
            visible={showDialogAyuda}
            onHide={() => setShowDialogAyuda(false)}
            header={setLabel('ayuda')}
            style={{ width: '40%' }}
            modal
          >
            <div style={{ lineHeight: '1.8', fontSize: '1rem' }}>
              <p>{setLabel('ayudaText')}</p>

              <p>
                <i className="pi pi-phone" style={{ marginRight: '8px' }}></i>
                <strong>Teléfono:</strong> +504 2625-4400 ext. 189 / 126
              </p>

              <p>
                <i className="pi pi-envelope" style={{ marginRight: '8px' }}></i>
                <strong>Email:</strong>{' '}
                <a href="mailto:administracion@ppf.com.hn">administracion@ppf.com.hn</a>
              </p>
            </div>
          </Dialog>
        )}
      </div>
    )
  }
};

export default InscripcionProveedores;
